<template>
  <div>
    <v-dialog
      v-model="show"
      :max-width="movimientoItem.idTipoMovimiento == 7 ? '1700px' : '1500px'"
      persistent
    >
    <signalr path="/hub/inventario" @change="notificacionInventario"></signalr>
    <notifications group="inventario" position="bottom right" :duration="10000"/>
    <v-snackbar
      v-model="error"
      color="red"
      top
    >
      <ul>
        <li v-for="(error,idx) in errores" :key="'error-'+idx">{{error}}</li>
      </ul>
    </v-snackbar>
    <v-dialog v-model="dialogAlertaMP" persistent max-width="450px">
      <v-card>
        <v-card-text class="pb-0">
          <div class="text-center py-2 pt-4">
            <lottie
              id="errorAlertaMP"
              :options="failedAnimationOptions"
              :height="100"
              :width="100"
              :key="`error-${lottieKey}`"
              class="py-0"
            />
          </div>
          <p class="text-h5 text--primary text-center">Ha intentado asignar una materia prima que no forma parte de la receta.</p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            color="error"
            :disabled="saving"
            @click="save(true,true)"
            >Sí, autorizo<br>la salida</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn 
            text 
            color="success"
            :disabled="saving"
            :loading="saving"
            @click="cerrarDialogAlertaMP()"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlertaMovimientoReciente" persistent max-width="600px">
      <v-card>
        <v-card-title>Alerta de Movimiento de Entrada reciente</v-card-title>
        <v-card-text class="pb-0">
          <div class="text-center">
            <lottie
              id="alertaMovimientoReciente"
              :options="attentionAnimationOptions"
              :height="200"
              :width="200"
              :key="`movreciente-${attentionAnimationKey}`"
              class="py-0"
            />
          </div>
          <p class="text-h6 text-justify text--primary font-weight-regular" style="font-size: 18px !important">
            Se está realizando una operación con un artículo al cual recientemente 
            se le hizo un movimiento de entrada de almacén. ¿Desea continuar con esta operación?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            color="error"
            :disabled="saving"
            @click="save(false,true)"
            >Continuar con<br>la operacion</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn 
            text 
            color="success"
            :disabled="saving"
            :loading="saving"
            @click="cerrarDialogAlertaMovimientoReciente()"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDesglosar" max-width="85%" persistent> <!--De aquí-->
			<v-card class="pb-6 pt-5">
				<v-card-title class="pb-2 pt-2">
					Desglosar Movimiento
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" md="12" sm="12">
							<div class="d-flex">
								<v-btn
									color="primary"
									@click="showDialogHistorial"
									:loading="loadingHistorial"
									:disabled="loadingHistorial || savingDesglosar"
									>Seleccionar Mantenimientos</v-btn
								>
								<v-btn
									v-if="movimientoDesglose.payload!== undefined"
									color="primary"
									class="ml-auto"
									@click="distribuirTotal"
									:disabled="loadingHistorial || savingDesglosar"
									>Distribuir {{ parseFloat(movimientoDesglose.cantidadFaltante).toFixed(2) }} {{movimientoDesglose.unidad}} </v-btn
								>

							</div>
							<v-data-table
								:items="movimientoDesglose.payload"
								:headers="headersDesglose"
								:footer-props="{
									disableItemsPerPage: true,
									disablePagination: this.loading,
								}"
								:disable-sort="true"
                hide-default-footer
                :items-per-page="-1"
							>
								<template
									v-slot:[`item.cantidad`]="{ index }"
								>
									<v-text-field
										v-model="cantidades[index]"
										:rules="[
											cantidadRule(cantidades[index]),
										]"
										class="centered-input"
										@blur="
											convert3D(cantidades[index], index)
										"
									></v-text-field>
								</template>
								<template
									v-slot:[`item.porcentaje`]="{ index }"
								>
									<!-- <v-text-field
										v-model="porcentajes[index]"
										:rules="[
											numberRule(porcentajes[index]),
										]"
										class="centered-input"
										suffix="%"
										@blur="
											convert2D(porcentajes[index], index)
										"
									></v-text-field> -->
									{{  porcentajes[index] }} %
								</template>
								
							</v-data-table>
						</v-col>
					</v-row>
					
					<ul class="d-flex">
						<li
							class="red--text"
							v-for="(error, idx) in errores"
							:key="'error' + idx"
						>
							{{ error }}
						</li>
						<div
							v-if="movimientoDesglose.payload!== undefined"
							:class="[errores.length > 0 ? ( totality !== 0 ? 'orange--text' : 'black--text' ):'green--text']"
							class="ml-auto"
							:key="'error' + idx"
						>
							SUMATORIA:  {{ (totality).toFixed(2) }} {{movimientoDesglose.unidad}}
						</div>
						
					</ul>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="red"
						@click="closeDesglosar"
						:disabled="savingDesglosar"
						>Cancelar</v-btn
					>
					<v-btn
						color="green"
						:disabled="
							savingDesglosar ||
							!cantidadesValidos
						"
						:loading="savingDesglosar"
						@click="guardarDesglosar"
					>
						Guardar
						<template v-slot:loader>
              <v-progress-circular
                indeterminate
                :width="2"
                :size="24"
                color="red"
              ></v-progress-circular>
            </template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
    <v-dialog v-model="dialogHistorial" max-width="90%" persistent>
			<v-card>
				<v-toolbar color="primary" dark>
					<v-btn icon dark @click="cerrarDialogHistorial">
						<v-icon>mdi-close</v-icon>
					</v-btn>

					<v-toolbar-title style="color: white"
						>Seleccionar Mantenimientos</v-toolbar-title
					>

					<v-spacer></v-spacer>

					<v-btn dark text @click="clickGuardarSelected">
						Seleccionar
					</v-btn>
				</v-toolbar>
				<v-card-text>
					<Historial ref="historyMan" :seleccionable="true" />
				</v-card-text>
			</v-card>
		</v-dialog> <!--Hasta aquí es lo nuevo del desglose-->
    <v-card>
      <v-card-title>
        Nuevo Movimiento
      </v-card-title>
      <v-card-text v-if="state == 0">
        <v-row v-if="movimientoItem.idTipoMovimiento == 2">
          <v-col cols="4" md="4" sm="4">
            <v-select
              :key="`tipo-mov-a-${tipoMovimientoSelectKey}`"
              v-model="movimientoItem.idTipoMovimiento"
              label="Tipo de Movimiento (Obligatorio)"
              :items="tipoMovimientosMov"
              item-text="nombre"
              item-value="idTipoMovimiento"
              @change="onSelectEntrada"
            ></v-select>
          </v-col>          
          <v-col cols="4" md="4" sm="4">
            <v-text-field
              v-model="movimientoItem.lote"
              label="Lote (Opcional)"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="4" md="4" sm="4">
            <v-autocomplete
              v-model="movimientoItem.idArticulo"
              label="Artículo (Obligatorio)"
              :items="articulos"
              item-value="idArticulo"
              :item-text="nombreArticulo"
              :loading="loadingArticulos"
              :disabled="loadingArticulos"
              @change="getArticuloTipo();setUnidad(movimientoItem.idArticulo)"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="movimientoItem.idTipoMovimiento != 2">
          <v-col :cols="movimientoItem.idTipoMovimiento == 7 ? 12 : 6" :md="movimientoItem.idTipoMovimiento == 7 ? 12 : 6" :sm="movimientoItem.idTipoMovimiento == 7 ? 12 : 6">
            <v-row>
              <v-col cols="12" md="12" sm="12" :class="movimientoItem.idTipoMovimiento != 2?'mb-0 pb-0':''">
                <v-select
                  :key="`tipo-mov-b-${tipoMovimientoSelectKey}`"
                  v-model="movimientoItem.idTipoMovimiento"
                  label="Tipo de Movimiento (Obligatorio)"
                  :items="tipoMovimientosMov"
                  item-text="nombre"
                  item-value="idTipoMovimiento"
                  @change="onSelectEntrada"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="(movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6)">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-autocomplete
                  label="Tipo de Salida"
                  v-model="movimientoItem.tipoSalida"
                  :items="tiposSalidas"
                  item-value="idTipoSalida"
                  item-text="nombre"
                  clearable
                  @change="changeTipoSalida()"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="((movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6) && movimientoItem.tipoSalida == 1)">
               <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idTrabajoOrden"
                  label="Orden de Trabajo"
                  :items="trabajoOrdenes"
                  item-value="idTrabajoOrden"
                  item-text="nombre"
                  @change="($event) => {
                    movimientoItem.idsTrabajoOrdenDetalle = [];
                    setDetalles($event);
                  }"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row  v-if="((movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6) && movimientoItem.tipoSalida == 1)">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idsTrabajoOrdenDetalle"
                  label="Artículo a Producir"
                  :items="trabajoOrdenDetalles"
                  item-value="idTrabajoOrdenDetalle"
                  item-text="articulo"
                  multiple
                  chips
                  clearable
                  deletable-chips
                  @click:clear="movimientoItem.idsTrabajoOrdenDetalle = [];"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="((movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6) && movimientoItem.tipoSalida == 1)">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idMaquina"
                  label="Máquina"
                  :items="maquinas"
                  item-value="idMaquinaIns"
                  :item-text="maquinaLabel"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="((movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6) && movimientoItem.tipoSalida == 1)">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idOperador"
                  label="Operador (Opcional)"
                  :items="operadores"
                  item-value="idPersona"
                  :item-text="operadorLabel"
                  clearable
                  @click:clear="onClearOperador"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="(movimientoItem.idTipoMovimiento == 1 && movimientoItem.tipoSalida == 1)">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-switch
                  v-model="sinQrProduccion"
                  label="Salida sin QR (por cantidad)"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                  @change="onToggleSinQrProduccion"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row v-if="((movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6) && movimientoItem.tipoSalida == 3)">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idOperador"
                  label="Recibió"
                  :items="operadores"
                  item-value="idPersona"
                  :item-text="operadorLabel"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="(movimientoItem.idTipoMovimiento == 1 && movimientoItem.tipoSalida == 5)">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idPublicoVenta"
                  label="Orden de Venta"
                  :items="ordenesVentaPublico"
                  item-value="idPublicoVenta"
                  item-text="clave"
                  clearable
                  :error-messages="errorOrdenVenta"
                  @focus="errorOrdenVenta=''"
                  @change="limpiarArticulosTabla()"
                  :loading="loadPublicoVenta"
                  :disabled="loadPublicoVenta"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="(movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6) && movimientoItem.tipoSalida == 2">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idCliente"
                  label="Cliente"
                  :items="clientes"
                  item-value="idCliente"
                  item-text="nombre"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="movimientoItem.idTipoMovimiento == 1 && (movimientoItem.tipoSalida == 1 || movimientoItem.tipoSalida == 2 || movimientoItem.tipoSalida == 4) && !esProduccionSinQr">
              <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                <v-switch
                  v-model="editarCantidadSalida"
                  label="Modificar cantidad a enviar"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                  @change="onToggleEditarCantidadSalida"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row v-if="(movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6) && movimientoItem.tipoSalida == 6">
              <v-col cols="12" md="6" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idAlmacenDestino"
                  label="Almacén destino"
                  :items="almacenesDestinoSalida"
                  :item-text="almacenUbicacionText"
                  item-value="idAlmacen"
                  clearable
                  @change="onChangeAlmacenDestinoSalida"
                ></v-autocomplete>
                <div class="caption grey--text mt-n2">
                  Selecciona el destino para cargar artículos de otros almacenes.
                </div>
              </v-col>
              <v-col cols="12" md="6" sm="12" class="my-0 py-0">
                <v-autocomplete
                  v-model="movimientoItem.idSubalmacenDestino"
                  label="Subalmacén destino"
                  :items="subalmacenesDestinoSalida"
                  :item-text="nombreSubalmacen"
                  item-value="idSubalmacen"
                  :disabled="!(movimientoItem.idAlmacenDestino > 0) || subalmacenesDestinoSalida.length == 0"
                  clearable
                  @change="onChangeSubalmacenDestinoSalida"
                ></v-autocomplete>
                <div class="caption grey--text mt-n2">
                  {{
                    subalmacenesDestinoSalida.length > 0
                      ? 'Selecciona el subalmacén destino para la transferencia.'
                      : 'El almacén destino no tiene subalmacenes activos; se enviará sin subalmacén.'
                  }}
                </div>
              </v-col>
            </v-row>
            <template v-if="esIngresoProduccion">
              <v-row>
                <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                  <v-autocomplete
                    v-model="movimientoItem.idTrabajoOrden"
                    label="Orden de Trabajo"
                    :items="trabajoOrdenes"
                    item-value="idTrabajoOrden"
                    item-text="nombre"
                    @change="onChangeOrdenProduccion"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" sm="12" class="my-0 py-0">
                  <v-autocomplete
                    v-model="movimientoItem.idTrabajoOrdenDetalle"
                    label="Artículo a mover"
                    :items="trabajoOrdenDetalles"
                    item-value="idTrabajoOrdenDetalle"
                    item-text="articulo"
                    clearable
                    @change="onChangeDetalleProduccion"
                    @click:clear="movimientoItem.idTrabajoOrdenDetalle = -1; produccionDisponible = null; cantidadIngreso = 0;"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="loadingProduccion">
                <v-col cols="12" class="text-center my-0 py-0">
                  <v-progress-circular indeterminate color="primary" :size="24" :width="2"></v-progress-circular>
                </v-col>
              </v-row>
              <v-row v-if="produccionDisponible && !loadingProduccion">
                <v-col cols="4" md="4" sm="4" class="my-0 py-0">
                  <div class="caption grey--text text--darken-1">Producido</div>
                  <div class="subtitle-1 font-weight-bold">
                    {{ formatoNumero(produccionDisponible.producido) }} {{ produccionDisponible.unidad }}
                  </div>
                </v-col>
                <v-col cols="4" md="4" sm="4" class="my-0 py-0">
                  <div class="caption grey--text text--darken-1">En almacén de PT</div>
                  <div class="subtitle-1 font-weight-bold">
                    {{ formatoNumero(produccionDisponible.enviadoAAlmacenPT) }} {{ produccionDisponible.unidad }}
                  </div>
                </v-col>
                <v-col cols="4" md="4" sm="4" class="my-0 py-0">
                  <div class="caption grey--text text--darken-1">Disponible por enviar</div>
                  <div
                    class="subtitle-1 font-weight-bold"
                    :class="produccionDisponible.diferencia > 0 ? 'green--text text--darken-2' : 'red--text text--darken-2'"
                  >
                    {{ formatoNumero(produccionDisponible.diferencia) }} {{ produccionDisponible.unidad }}
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="produccionDisponible && !loadingProduccion">
                <v-col cols="12" md="6" sm="12" class="my-0 py-0">
                  <v-autocomplete
                    v-model="movimientoItem.idAlmacenDestino"
                    label="Almacén destino"
                    :items="almacenes"
                    :item-text="almacenUbicacionText"
                    item-value="idAlmacen"
                    clearable
                    @change="movimientoItem.idSubalmacenDestino = null"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" sm="12" class="my-0 py-0">
                  <v-autocomplete
                    v-model="movimientoItem.idSubalmacenDestino"
                    label="Subalmacén destino"
                    :items="subalmacenesDestinoSalida"
                    :item-text="nombreSubalmacen"
                    item-value="idSubalmacen"
                    :disabled="!(movimientoItem.idAlmacenDestino > 0) || subalmacenesDestinoSalida.length == 0"
                    clearable
                  ></v-autocomplete>
                  <div class="caption grey--text mt-n2">
                    {{
                      !(movimientoItem.idAlmacenDestino > 0)
                        ? 'Selecciona primero el almacén destino.'
                        : (subalmacenesDestinoSalida.length > 0
                          ? 'Selecciona el subalmacén destino.'
                          : 'El almacén destino no tiene subalmacenes activos.')
                    }}
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="produccionDisponible && !loadingProduccion">
                <v-col cols="12" md="6" sm="12" class="my-0 py-0">
                  <v-text-field-number
                    v-model="cantidadIngreso"
                    :label="'Cantidad a ingresar (Máximo: ' + formatoNumero(produccionDisponible.diferencia) + ' ' + produccionDisponible.unidad + ')'"
                    :max="produccionDisponible.diferencia"
                    decimal
                    dense
                  ></v-text-field-number>
                </v-col>
              </v-row>
            </template>
            <v-row v-if="movimientoItem.idTipoMovimiento == 7">
              <v-col cols="12">
                <div class="text-center">
                  <h3>Movimiento entre ubicaciones de almacén</h3>
                </div>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-switch
                  v-model="modoUbicacionQR"
                  label="Por QR"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                  @change="onToggleModoUbicacionQR"
                ></v-switch>
              </v-col>
              <template v-if="!modoUbicacionQR">
              <v-col cols="3" md="3" sm="12">
                <v-autocomplete
                  v-model="movimientoUbicacionItem.idAlmacen"
                  label="Almacén"
                  :items="almacenesConInventarioUbicacion"
                  :item-text="almacenUbicacionText"
                  item-value="idAlmacen"
                  @change="onChangeAlmacenUbicacion"
                ></v-autocomplete>
                <div class="caption grey--text mt-n2">
                  Selecciona un almacén para cargar sus artículos con existencia.
                </div>
              </v-col>
              <v-col cols="3" md="3" sm="12">
                <v-autocomplete
                  v-model="movimientoUbicacionItem.idArticulo"
                  label="Nombre"
                  :items="articulosDisponiblesUbicacion"
                  :item-text="nombreArticulo"
                  item-value="idArticulo"
                  :loading="loadingMovimientosUbicacion"
                  :disabled="movimientoUbicacionItem.idAlmacen == null || loadingMovimientosUbicacion"
                  @change="onChangeArticuloUbicacion"
                ></v-autocomplete>
                <div class="caption grey--text mt-n2">
                  Solo se muestran artículos con inventario en el almacén seleccionado.
                </div>
              </v-col>
              <v-col cols="3" md="3" sm="12">
                <v-autocomplete
                  v-model="movimientoUbicacionItem.idSubalmacenOrigen"
                  label="Ubicación actual"
                  :items="subalmacenesOrigenUbicacion"
                  :item-text="nombreSubalmacen"
                  item-value="idSubalmacen"
                  :disabled="movimientoUbicacionItem.idArticulo == null"
                  @change="onChangeSubalmacenOrigenUbicacion"
                ></v-autocomplete>
                <div class="caption grey--text mt-n2">
                  Si no aparece, selecciona "Sin subalmacén asignado" para asignarlo aquí.
                </div>
              </v-col>
              <v-col cols="3" md="3" sm="12">
                <v-autocomplete
                  v-model="movimientoUbicacionItem.idSubalmacenDestino"
                  label="Ubicación nueva"
                  :items="subalmacenesDestinoUbicacion"
                  :item-text="nombreSubalmacen"
                  item-value="idSubalmacen"
                  :disabled="movimientoUbicacionItem.idSubalmacenOrigen == null"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" sm="12">
                <v-text-field-number
                  v-model="movimientoUbicacionItem.cantidad"
                  :label="infoArticuloUbicacion ? ('Cantidad a mover (Máx: ' + infoArticuloUbicacion.maximo + (infoArticuloUbicacion.abreviatura ? ' ' + infoArticuloUbicacion.abreviatura : '') + ')') : 'Cantidad a mover'"
                  :max="infoArticuloUbicacion ? infoArticuloUbicacion.maximo : null"
                  decimal
                  dense
                  :disabled="infoArticuloUbicacion == null"
                ></v-text-field-number>
                <div class="caption grey--text mt-n2">
                  Por defecto se mueve todo; captura menos si solo quieres una parte.
                </div>
              </v-col>
              <v-col cols="12" md="8" sm="12" class="text-right align-self-center">
                <v-btn color="primary" :disabled="!puedeAgregarMovimientoUbicacion" @click="agregarMovimientoUbicacion">Guardar</v-btn>
              </v-col>
              <v-col cols="12">
                <v-data-table
                  :headers="headersMovimientosUbicacion"
                  :items="movimientosUbicacion"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom color="black" class="white--text">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small @click="eliminarMovimientoUbicacion(item)">mdi-delete</v-icon>
                      </template>
                      <span class="white--text">Eliminar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
                <ul v-if="erroresUbicacion.length">
                  <li v-for="(mensaje, idx) in erroresUbicacion" :key="'error-ubicacion-'+idx" class="red--text">
                    {{ mensaje }}
                  </li>
                </ul>
              </v-col>
              </template>

              <template v-else>
                <v-col cols="12" md="3" sm="12">
                  <qrcode-stream @decode="onDecodeUbicacionQR" style="height: 15.625rem"></qrcode-stream>
                  <v-text-field
                    v-model="ubicacionQRCodigo"
                    label="Código de Identificación"
                    hide-details
                    maxlength="12"
                    class="py-2"
                    @keydown.enter="getCodeUbicacionQR"
                    @keyup="setCodeStyleUbicacionQR"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="9" sm="12">
                  <v-data-table
                    :headers="headersUbicacionQR"
                    :items="movimientosUbicacionQR"
                    :items-per-page="-1"
                    hide-default-footer
                  >
                    <template v-slot:[`item.codigo`]="{ item }">{{ setCodeStyleReturn(item.codigo) }}</template>
                    <template v-slot:[`item.subalmacen`]="{ item }">{{ item.subalmacen || 'Sin subalmacén' }}</template>
                    <template v-slot:[`item.subalmacenDestino`]="{ item }">
                      <v-autocomplete
                        v-model="item.idSubalmacenDestino"
                        label="Ubicación nueva"
                        :items="subalmacenesDestinoUbicacionQR(item)"
                        :item-text="nombreSubalmacen"
                        item-value="idSubalmacen"
                        dense
                        hide-details
                      ></v-autocomplete>
                    </template>
                    <template v-slot:[`item.cantidad`]="{ item }">
                      <v-text-field-number
                        v-model="item.cantidad"
                        :label="'Máx: ' + item.maximo + (item.abreviatura ? ' ' + item.abreviatura : '')"
                        :max="item.maximo"
                        decimal
                        dense
                        hide-details
                      ></v-text-field-number>
                    </template>
                    <!-- Folio nuevo en movimiento entre ubicaciones DESACTIVADO a solicitud (arrastra folio original):
                    <template v-slot:[`item.folioNuevo`]="{ item }">
                      <v-text-field
                        v-model="item.folioNuevo"
                        :disabled="parseFloat(item.cantidad) >= item.maximo"
                        placeholder="[Opcional] Folio"
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    -->
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip bottom color="black" class="white--text">
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small @click="eliminarUbicacionQR(item)">mdi-delete</v-icon>
                        </template>
                        <span class="white--text">Eliminar</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                  <ul v-if="erroresUbicacion.length">
                    <li v-for="(mensaje, idx) in erroresUbicacion" :key="'error-ubq-'+idx" class="red--text">{{ mensaje }}</li>
                  </ul>
                  <div class="caption grey--text mt-1">Por defecto se mueve toda la tarima; captura menos para mover solo una parte.</div>
                </v-col>
              </template>
            </v-row>
          </v-col>
          <v-col cols="6" md="6" sm="6" v-if="usaCapturaCodigoQR">
            <v-row>
              <div>
              <qrcode-stream @decode="onDecode"></qrcode-stream>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" sm="6">
                <v-text-field
                  v-model="codigo"
                  label="Código de Identificación"
                  v-if="(movimientoItem.idTipoMovimiento
                   == 1 || movimientoItem.idTipoMovimiento == 6) || movimientoItem.idTipoMovimiento == 4"
                  hide-details
                  @keydown.enter="getCode"
                  @keyup="setCodeStyle"
                  maxlength="12"
                  :error="!(validCode(codigo) && codigo.length >= 11 && codigo.length <= 12) && codigo.length >= 1"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="6">
                <v-select
                  v-model="selectCode"
                  label="Lectura Remota"
                  :loading="loadingLecturasRemotas"
                  :items="lecturasRemotas"
                  item-value="codigo"
                  item-text="codigo"
                  @input="selectedCode"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>{{data.item.codigo}}</v-list-item-title>
                      <v-list-item-subtitle>Artículo: {{data.item.articulo}}</v-list-item-subtitle>
                      <v-list-item-subtitle>Almácen: {{data.item.almacen}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" md="6" sm="6" v-if="esProduccionSinQr">
            <v-row>
              <v-col cols="12" md="6" sm="6" class="py-0">
                <v-autocomplete
                  v-model="sinQrItem.idAlmacen"
                  label="Almacén origen"
                  :items="almacenes"
                  :item-text="almacenText"
                  item-value="idAlmacen"
                  @change="sinQrItem.maximo = null"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" sm="6" class="py-0">
                <v-autocomplete
                  v-model="sinQrItem.idArticulo"
                  label="Materia prima"
                  :items="materiasPrimas"
                  item-value="idArticulo"
                  :item-text="nombreArticulo"
                  @change="onChangeArticuloSinQr"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="8" sm="8" class="py-0">
                <v-text-field-number
                  :key="'sinqr-cant-' + sinQrCantidadKey"
                  v-model="sinQrItem.cantidad"
                  :label="'Cantidad' + (sinQrItem.maximo != null ? ' (Disponible: ' + sinQrItem.maximo + ')' : '')"
                  decimal
                  dense
                  hide-details
                ></v-text-field-number>
                <div class="caption grey--text mt-n1">
                  Solo se puede mover materia prima con stock disponible.
                </div>
              </v-col>
              <v-col cols="12" md="4" sm="4" class="d-flex align-center py-0">
                <v-btn
                  color="primary"
                  block
                  :disabled="!puedeAgregarSinQr || saving"
                  :loading="loadingSinQrStock"
                  @click="agregarSalidaProduccionSinQr()"
                >
                  Agregar
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" md="6" sm="6" v-if="esSalidaAAlmacen">
            <v-row>
              <v-col cols="12" md="9" sm="8">
                <v-autocomplete
                  v-model="articuloSalidaAlmacenKey"
                  label="Artículos"
                  :items="articulosDisponiblesSalidaAlmacen"
                  :item-text="articuloSalidaAlmacenText"
                  item-value="key"
                  :disabled="!(movimientoItem.idAlmacenDestino > 0)"
                  :placeholder="movimientoItem.idAlmacenDestino > 0 ? '' : 'Selecciona primero Almacén destino'"
                  :persistent-placeholder="!(movimientoItem.idAlmacenDestino > 0)"
                  clearable
                  @keydown.enter.prevent="agregarArticuloSalidaAlmacen()"
                ></v-autocomplete>
                <div class="caption grey--text mt-n2">
                  Se muestran artículos con existencia en almacenes distintos al destino seleccionado.
                </div>
              </v-col>
              <v-col cols="12" md="3" sm="4" class="d-flex align-center">
                <v-btn
                  color="primary"
                  block
                  :disabled="!puedeAgregarArticuloSalidaAlmacen || saving"
                  @click="agregarArticuloSalidaAlmacen()"
                >
                  Agregar
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="movimientoItem.idTipoMovimiento == 2">
          <v-col cols="4" md="4" sm="4" class="pt-5">
            <VueCtkDateTimePicker
              v-model="movimientoItem.fechaRecepcion"
              label="Fecha de Recepción (Obligatorio)"
              format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm"
              noHeader
              overlay
              id="fecrec"
              buttonNowTranslation="Ahora"
            />
          </v-col>
          <v-col cols="4" md="4" sm="4">
            <v-autocomplete
              v-model="movimientoItem.idAlmacen"
              label="Almacén (Obligatorio)"
              :items="almacenes"
              :item-text="almacenText"
              item-value="idAlmacen"
              @change="changeAlmacen()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" md="4" sm="4">
            <v-autocomplete
              v-model="movimientoItem.idSubalmacen"
              label="Subalmacén (Opcional)"
              :items="subalmacenesComputed"
              :item-text="nombreSubalmacen"
              item-value="idSubalmacen"
              clearable
            ></v-autocomplete>
          </v-col>
          <!-- <v-col cols="6" md="6" sm="6">
            <VueCtkDateTimePicker
              v-model="movimientoItem.fechaIngreso"
              label="Fecha de Ingreso"
              format="YYYY-MM-DD HH:mm"
              formatted="YYYY-MM-DD HH:mm"
              noHeader
              overlay
              id="fecing"
              buttonNowTranslation="Ahora"
            />
          </v-col> -->
        </v-row>
        <v-row v-if="movimientoItem.idTipoMovimiento == 2">
          
          <v-col cols="6" md="6" sm="6">
            <v-autocomplete
              v-model="movimientoItem.idCalidadTipo"
              label="Tipo de Calidad (Obligatorio)"
              :items="calidadTipos"
               item-text="nombre"
              item-value="idCalidadTipo"
            ></v-autocomplete>
          </v-col>
          <v-col v-if="movimientoItem.idArticuloTipo == 3" cols="6" md="6" sm="6" class="my-0 py-0">
            <v-autocomplete
              v-model="movimientoItem.idTrabajoOrden"
              label="Orden de Trabajo (Opcional)"
              :items="trabajoOrdenes"
              item-value="idTrabajoOrden"
              item-text="nombre"
              clearable
              @change="($event) => {
                movimientoItem.idTrabajoOrdenDetalle=-1;
                setDetalles($event);
              }"
              @click:clear="
                movimientoItem.idTrabajoOrden=-1;
                movimientoItem.idTrabajoOrdenDetalle=-1
              "
            ></v-autocomplete>
          </v-col>
          <v-col v-if="movimientoItem.idArticuloTipo == 3" cols="6" md="6" sm="6" class="my-0 py-0">
            <v-autocomplete
              v-model="movimientoItem.idTrabajoOrdenDetalle"
              label="Artículo a Producir (Opcional)"
              :items="trabajoOrdenDetalles"
              item-value="idTrabajoOrdenDetalle"
              item-text="articulo"
              clearable
              @click:clear="movimientoItem.idTrabajoOrdenDetalle=-1"
            ></v-autocomplete>
          </v-col>
          <v-col v-if="movimientoItem.idTipoMovimiento == 2" cols="6" md="6" sm="6">
            <v-textarea  label="Descripción (Opcional)" auto-grow rows="1" v-model="movimientoItem.descripcion" counter="110" maxlength="110"></v-textarea>
          </v-col>
        </v-row>
        
        <div v-if="movimientoItem.idTipoMovimiento == 2">
          <div class="text-center">
            <h3>Proveedores</h3>
          </div>
          <br>
          <v-data-table
            :items="movimientoItem.proveedores"
            :headers="headersProveedores"
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:[`item.tipoProveedor`]="{ item }">
              <v-autocomplete
                v-model="item.idProveedorTipo"
                :items="proveedorTipos"
                :item-text="proveedorTipoLabel"
                item-value="idProveedorTipo"
                :class="(item.idProveedorTipo <= 0)?' v-input--is-focused':''"
                :error="(item.idProveedorTipo <= 0)"
                dense
              >
              </v-autocomplete>
            </template>
            <template v-slot:[`item.proveedor`] ="{ item }">
              <v-autocomplete
                v-model="item.idProveedor"
                :items="listaProveedores"
                :item-text="proveedorLabel"
                item-value="idProveedor"
                :class="(item.idProveedor <= 0)?' v-input--is-focused':''"
                :error="(item.idProveedor <= 0)"
                dense
              >
              </v-autocomplete>
            </template>
            <template v-slot:[`item.actions`] ="{ item }">
              <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
                small
                @click="deleteProveedor(item)"
              >
                mdi-delete
              </v-icon>
           </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>
            </template>
          </v-data-table>
          <v-btn
            text
            color="primary"
            @click="newProveedor"
          >
            Agregar Proveedor
          </v-btn>
          <br>
          <br>
          <!-- Tabla de elementos -->
          <div class="text-center">
            <!-- Titulo de la tabla elementos -->
            <h3>Elementos</h3>
          </div>
          <br>
          <!-- Declaracion de la tabla -->
          <v-data-table
            :items="movimientoItem.elementos"
            :headers="headersElementos"
            hide-default-footer
            :items-per-page="-1"
          >
          <!-- Columna que indica el Numero de envases -->
            <template v-slot:[`item.multiplicar`]="{ item }">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" md="12" sm="12" class="ma-0 pa-0">
                  <v-text-field
                    v-model="item.multiplicar"
                    type="number"
                    min="0"
                    dense
                    :error="validarCantidad(item.multiplicar,0.999999)"
                    :class="validarCantidad(item.multiplicar,0.999999)?' v-input--is-focused':''"
                  ></v-text-field>
                </v-col>
              </v-row>

            </template>
            <!-- Columna que indica el volumen del envase -->
            <template v-slot:[`item.cantidad`]="{ item }">
              <v-row class="ma-0 pa-0">
                <v-col cols="8" md="8" sm="8" class="ma-0 pa-0">
                  <!-- recuperarDato -->
                  <v-text-field
                    v-model="item.cantidad"
                    type="number"
                    min="0"
                    dense
                    
                    
                    :append-outer-icon="recuperarDatos && unidad.toLowerCase() === 'kilogramo' ? 'mdi-reload' : ''"
                    :loading="loadRecorverDate"
                    :error="validarCantidad(item.cantidad)"
                    :class="validarCantidad(item.cantidad)?' v-input--is-focused':''"
                  >
                  <template v-slot:append-outer>
                    <v-btn 
                    v-if="recuperarDatos && unidad.toLowerCase() === 'kilogramo'"
                        icon 
                        @click="emitirRecuperarDato(1, item)"
                        :disabled="loadRecorverDate"
                        :class="['custom-btn']"
                    >
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                </template>
                </v-text-field>
                </v-col>
                <v-col cols="4" md="4" sm="4" class="ma-0 pa-0" style="align-self:center !important;">
                  <v-container class="ma-0 pa-0 text-center">
                    {{$utils.strings.pluralizar(unidad,item.cantidad)}}
                  </v-container>
                </v-col>
              </v-row>
            <!-- Columna que indica el folio, el cual es opcional -->
            </template>
            <template v-slot:[`item.Folio`]="{ item }">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" md="12" sm="12" class="ma-0 pa-0">
                  <v-text-field
                    v-model="item.Folio"
                    dense
                    placeholder="Folio (Opcional)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
            <!-- Columna que indica el lote, el cual es opcional -->
            <template v-slot:[`item.lote`]="{ item }">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" md="12" sm="12" class="ma-0 pa-0">
                  <v-text-field
                    v-model="item.lote"
                    dense
                    placeholder="Lote (Opcional)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
            <!-- Columna que alberga los botones de acciones del registros -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
                small
                @click="deleteElemento(item)"
              >
                mdi-delete
              </v-icon>
               </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>
            </template>
          </v-data-table>
          <v-btn
            text
            color="primary"
            @click="newElemento"
          >
            Agregar Elemento
          </v-btn>

          <div class="text-right">
            <div class="display-1">
              Total: {{totalElementos.toFixed(2)}} {{$utils.strings.pluralizar(unidad,totalElementos)}}
            </div>
          </div>
        </div>
        <v-row v-if="esProduccionSinQr">
          <v-col cols="12" md="12" sm="12">
            <div class="text-center">
              <h3>Materias primas a producción</h3>
            </div>
            <br>
            <v-data-table
              :headers="headersSalidasSinQr"
              :items="salidasProduccionSinQr"
              :items-per-page="-1"
              hide-default-footer
              no-data-text="Agrega materias primas con stock disponible"
            >
              <template v-slot:[`item.cantidad`]="{ item }">
                {{ Number(item.cantidad).toFixed(2) }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom color="black" class="white--text">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small @click="eliminarSalidaProduccionSinQr(item)">mdi-delete</v-icon>
                  </template>
                  <span class="white--text">Eliminar</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row v-if="(movimientoItem.idTipoMovimiento == 1 || movimientoItem.idTipoMovimiento == 6) && !esIngresoProduccion && !esProduccionSinQr">
          <v-col cols="12" md="12" sm="12">
            <div class="text-center">
              <h3>Salidas</h3>
            </div>
            <br>
            <v-data-table
              :headers="headersTablaSalidas"
              :items="movimientoItem.salidas"
              :items-per-page="-1"
              hide-default-footer
            >
              <template v-slot:[`item.codigo`]="{ item }">
                {{setCodeStyleReturn(item.codigo)}}
              </template>
              <template v-slot:[`item.cantidadRequerida`]="{ item }">
                <p class="mb-0">{{ `${item.cantidadRequerida.toFixed(2)} ${item.abreviatura}` }}</p>
              </template>
              <template v-slot:[`item.cantidad`]="{ item }">
                <div class="d-flex align-center">
                  <v-text-field-number
                    v-model="item.cantidad"
                    :label="'Cantidad (Máximo: ' + item.maximo.toFixed(2) + ' ' + item.abreviatura + ')'"
                    :max="item.maximo"
                    :errorStatus="erroresCantidades.includes(item.idArticulo)"
                    :disabled="movimientoItem.idTipoMovimiento == 1 && (movimientoItem.tipoSalida == 1 || movimientoItem.tipoSalida == 2 || movimientoItem.tipoSalida == 4) && !editarCantidadSalida"
                    hide-details
                    dense
                    decimal
                    @focus="erroresCantidades = erroresCantidades.filter(idArticulo => idArticulo !== item.idArticulo)"
                    class="mr-2"
                  ></v-text-field-number>
              
                  <v-btn
                    v-if="recuperarDatos && item.abreviatura.toLowerCase() === 'kg'"
                    icon
                    @click="emitirRecuperarDato(2, item)"
                    :disabled="loadRecorverDate"
                    class="custom-btn"
                  >
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                </div>
              
              </template>
              <!-- Folio nuevo en salida parcial DESACTIVADO a solicitud (arrastra folio original):
              <template v-slot:[`item.folioNuevo`]="{ item }">
                <v-text-field
                  v-model="item.folioNuevo"
                  dense
                  hide-details
                  placeholder="[Opcional] Folio nuevo"
                ></v-text-field>
              </template>
              -->
              <template v-slot:[`item.detalles`]="{ item }">
                <ul>
                  <li v-for="(proveedor,idx) in item.proveedores" :key="'proveedor-'+item.codigo+'-'+idx">
                    <b>{{proveedor.proveedorTipo}}:</b> {{proveedor.proveedor}}
                  </li>
                </ul>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
                  small
                  @click="deleteSalida(item)"
                >
                  delete
                </v-icon>
                 </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>
      <!--Agregado para el desglose--><v-tooltip
					v-if="permisoVista('movimientos-sindesglosar', 'c') && permisoVista('movimientos-sindesglosar', '$')"
					
					bottom
					color="black"
					class="white--text"
				>
					<template v-slot:activator="{ on }">
						<v-icon v-on="on" small @click="desglosarMovimiento(item)">
							mdi-file-tree
						</v-icon>
					</template>
					<span class="white--text">Desglosar</span>
				</v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row v-if="movimientoItem.idTipoMovimiento == 4">
          <v-col cols="12" md="12" sm="12">
            <div class="text-center">
              <h3>Reintegros</h3>
            </div>
            <br>
            <v-data-table
              :items="movimientoItem.reintegros"
              :items-per-page="-1"
              :headers="headersReintegros"
              hide-default-footer
              :expanded.sync="expanded"
              item-key="idElemento"
              show-expand
            >
              <template v-slot:[`item.indice`]="{ index }">
                <p class="mb-0">{{index+1}}</p>
              </template>
              <template v-slot:[`item.cantidad`]="{ item, index }">
                <v-row>
                  <v-col cols="8" md="8" sm="8" class="ma-0">
                    <v-text-field
                      v-model="item.cantidad"
                      :label="'Maximo: '+ item.maximo"
                      type="number"
                      min="0"
                      dense
                      hide-details
                      :error="
                        validarCantidad(item.cantidad,0.0) || 
                        parseFloat(item.cantidad) > item.maximo || 
                        (expanded.indexOf(item)==-1&&validarCantidadMenor(item))
                      "
                      :class="
                        (validarCantidad(item.cantidad,0.0) || 
                        parseFloat(item.cantidad) > item.maximo || 
                        (expanded.indexOf(item)==-1&&validarCantidadMenor(item)))
                        ?' v-input--is-focused'
                        :''
                      "
                      @input="validarCantidadDesglose(index)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" md="4" sm="4" class="ma-0 pa-0 align-self-center">
                    {{$utils.strings.pluralizar(item.unidad,item.cantidad)}}
                  </v-col>
                </v-row>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom color="black" class="white--text text-center">
          <template v-slot:activator="{ on }">
        <v-icon v-on="on"
                  small
                  @click="deleteReintegro(item)"
                >
                  delete
                </v-icon>
                 </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>
              </template>
              <template v-slot:[`item.data-table-expand`]="{ item, isExpanded }">
                <v-tooltip v-if="item.trabajoOrdenes.ordenesTrabajoDetalle.length>0" bottom color="black" class="white--text text-center">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="desglosarReintegro(item, isExpanded)">
                      {{isExpanded?'mdi-close':'mdi-chevron-down'}}
                    </v-icon>
                  </template>
                  <span class="white--text">{{isExpanded?'Cancelar':'Desglosar'}}</span>
                </v-tooltip>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="px-4" style="background-color: white !important">
                  <h3 class="text--secondary text-center mb-1 mt-2">Desgloses</h3>
                  <v-data-table
                    :items="item.trabajoOrdenes.ordenesTrabajoDetalle"
                    :headers="headersOTD"
                    :items-per-page="-1"
                    hide-default-footer
                  >
                    <template v-slot:[`item.indice`]="{ index }">
                      <p class="mb-0">{{index+1}}</p>
                    </template>
                    <template v-slot:[`item.cantidad`]="{ item: itemDetalle }">
                      <v-text-field
                        v-model="itemDetalle.cantidad"
                        type="number"
                        class="centered-input px-10"
                        min="0"
                        dense
                        :error="itemDetalle.valido===false"
                        :class="itemDetalle.valido===false?'v-input--is-focused':''"
                        :suffix="$utils.strings.pluralizar(item.unidad,itemDetalle.cantidad)"
                        @input="validarCantidadDesglose(item)"
                      ></v-text-field>
                    </template>
                  </v-data-table>
                  <ul class="my-4">
                    <li 
                      v-for="mensaje,idx in item.msgDesgloses"
                      :key="idx"
                      class="red--text"
                    >
                      {{mensaje}}
                    </li>
                  </ul>
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="state == 1" class="text-center">
        <lottie id="alertaSaved" :options="checkOptions" :height="200" :width="200"/>
          <h3>Movimiento Guardado Correctamente</h3>
          <a class="headline" href="#" @click.prevent="descargarQRCodigosGuardado">
            <v-icon color="primary" large>mdi-download</v-icon> Descargar Códigos QR
          </a>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="close(state)">{{state == 0?'Cancelar':'Cerrar'}}</v-btn>
        <v-btn v-if="state == 0" color="red darken-1" text @click="save()" :disabled="saving" :loading="saving">
          Guardar
          <template v-slot:loader>
            <v-progress-circular
              indeterminate
              :width="2"
              :size="24"
              color="red"
            ></v-progress-circular>
          </template>
        </v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>
    <WizardNuevoMovimientoLogi 
      :show="showWizard" 
      @change="showWizard = false; close(1)" 
    />
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
import Lottie from 'vue-lottie';
import * as checkData from '@/assets/check.json';
import * as attentionAnimation from '@/assets/attention.json';
import * as failedAnimation from '@/assets/failed.json';
import { QrcodeStream } from 'vue-qrcode-reader'
import {Howl, Howler} from 'howler';
import { mapState } from 'vuex';
import VTextFieldNumber from "@/components/VTextFieldNumber";
import signalr from "@/components/SignalR";
import Historial from "../../Mantenimiento/Historial.vue";
import WizardNuevoMovimientoLogi from "./WizardNuevoMovimientoLogi.vue";

export default {
  components:{
    'lottie': Lottie,
    QrcodeStream,
    VTextFieldNumber,
    signalr,
    Historial,
    WizardNuevoMovimientoLogi
  },
  props:{
    show:{
      type:Boolean,
      default: false,
    }
  },
  data: () => ({
    loadRecorverDate: false,
    tipoMovimientoSelectKey: 0,
    subalmacenes: [],
    articulosTipos: [],
    maximo: null,
    IdElemento: null,
    attentionAnimationKey: 0,
    attentionAnimationOptions: {
      animationData: attentionAnimation.default,
      loop:false,
      speeed: 2
    },
    dialogAlertaMovimientoReciente: false,
    movimientoRecienteItem: {
      movimientoReciente: false,
      usuario: "",
      fecha: "",
      cantidad: ""
    },
    defaultMovimientoRecienteItem: {
      movimientoReciente: false,
      usuario: "",
      fecha: "",
      cantidad: ""
    },
    errorOrdenVenta: "",
    erroresCantidades: [],
    editarCantidadSalida: false,
    ordenesVentaPublico: [],
    loadPublicoVenta :false,
    msgDesgloses: [],
    desgloseIndex: -1,
    headersOTD: [
      {
        text: '#',
        value: 'indice',
        width: "5%",
        align: 'center',
        sortable: false,
      },
      {
        text: 'Articulo a Producir',
        value: 'articuloProducir',
        align: 'center',
        width: "70%",
        sortable: false,
      },
      {
        text: 'Cantidad',
        value: 'cantidad',
        align: 'center',
        width: "30%",
        sortable: false,
      },
    ],
    expanded: [],
    failedAnimationOptions: {
      animationData: failedAnimation.default,
      loop:false,
      speeed: 2
    },
    dialogAlertaMP: false,
    lottieKey: 0,
    codigo:'',
    state: 0,
    qrPdf:'',
    clientes:[],
    articulos:[],
    almacenes:[],
    calidadTipos:[],
    loadingArticulos:false,
    trabajoOrdenes:[],
    trabajoOrdenDetalles:[],
    errores:[],
    error: false,
    saving:false,
    showWizard: false,
    tipoMovimientos:[
      {
        nombre:"Entrada",
        idTipoMovimiento:2
      },
      {
        nombre:"Salida",
        idTipoMovimiento:1
      },
      {
        nombre:"Salida Parcial",
        idTipoMovimiento:6
      },
      {
        nombre:"Movimiento entre ubicaciones de almacén",
        idTipoMovimiento:7
      },
      {
        nombre:"Reintegro",
        idTipoMovimiento:4
      },
      {
        nombre:"Excedente",
        idTipoMovimiento:3
      }
    ],
    unidad:'',
    movimientoItem:{
      idPublicoVenta: null,
      idArticulo:-1,
      idTipoMovimiento: -1,
      cantidad:0,
      idTrabajoOrden:-1,
      idTrabajoOrdenDetalle:-1,
      idsTrabajoOrdenDetalle: [],
      unidad:"",
      fechaRecepcion:null,
      fechaIngreso:null,
      idAlmacen: -1,
      idSubalmacen: null,
      idCalidadTipo: -1,
      proveedores:[],
      elementos:[],
      idMaquina:-1,
      idOperador:-1,
      salidas:[],
      reintegros:[],
      desgloses:[], //añadido pal desglose
      descripcion:"",
      tipoSalida:-1,
      idCliente: -1,      
      idAlmacenDestino: -1,
      idSubalmacenDestino: null,
      lote: "",
      idArticuloTipo: -1
    },
    articulosSinQr: [],
    articulosCatalogoRaw: [],
    movimientosEntradasAlmacen: [],
    movimientosEntradasGenerales: [],
    loadingMovimientosUbicacion: false,
    loadingSaldosArticulosUbicacion: false,
    movimientosUbicacion: [],
    erroresUbicacion: [],
    infoArticuloUbicacion: null,
    infoArticuloUbicacionApi: null,
    saldosArticulosUbicacionApi: {},
    sinSubalmacenDisponibleUbicacion: false,
    saldosSubalmacenUbicacion: {},
    saldoArticuloRequestId: 0,
    saldoSubalmacenRequestId: 0,
    articuloSalidaAlmacenKey: null,
    produccionDisponible: null,
    loadingProduccion: false,
    cantidadIngreso: 0,
    sinQrProduccion: false,
    sinQrItem: {
      idAlmacen: -1,
      idArticulo: -1,
      cantidad: undefined,
      maximo: null
    },
    salidasProduccionSinQr: [],
    loadingSinQrStock: false,
    sinQrCantidadKey: 0,
    headersSalidasSinQr: [
      { text: 'Almacén', value: 'almacen', align: 'start', sortable: false },
      { text: 'Materia prima', value: 'articulo', align: 'start', sortable: false },
      { text: 'Cantidad', value: 'cantidad', align: 'end', sortable: false },
      { text: 'Acciones', value: 'actions', align: 'center', sortable: false }
    ],
    movimientoUbicacionItem: {
      idAlmacen: null,
      idArticulo: null,
      idSubalmacenOrigen: null,
      idSubalmacenDestino: null,
      // undefined (no null) para que el campo numérico se vea vacío por defecto (no "null").
      cantidad: undefined
    },
    modoUbicacionQR: false,
    ubicacionQRCodigo: "",
    movimientosUbicacionQR: [],
    headersUbicacionQR: [
      { text: "Clave", value: "codigo", align: "center", sortable: false },
      { text: "Artículo", value: "articulo", align: "center", sortable: false },
      { text: "Almacén", value: "almacen", align: "center", sortable: false },
      { text: "Ubicación actual", value: "subalmacen", align: "center", sortable: false },
      { text: "Ubicación nueva", value: "subalmacenDestino", align: "center", sortable: false, width: "20%" },
      { text: "Cantidad a mover", value: "cantidad", align: "center", sortable: false, width: "18%" },
      // Folio nuevo en movimiento entre ubicaciones DESACTIVADO a solicitud (arrastra folio original):
      // { text: "Folio nuevo", value: "folioNuevo", align: "center", sortable: false, width: "14%" },
      { text: "", value: "actions", align: "center", sortable: false, width: "5%" },
    ],
    headersMovimientosUbicacion: [
      {
        text: "Almacén",
        value: "almacen",
        align: "center",
        sortable: false
      },
      {
        text: "Nombre",
        value: "articulo",
        align: "center",
        sortable: false
      },
      {
        text: "Ubicación actual",
        value: "subalmacenOrigen",
        align: "center",
        sortable: false
      },
      {
        text: "Ubicación nueva",
        value: "subalmacenDestino",
        align: "center",
        sortable: false
      },
      {
        text: "Cantidad",
        value: "cantidadLabel",
        align: "center",
        sortable: false
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        sortable: false
      }
    ],
    defaultItem:{
      idPublicoVenta: null,
      idArticulo:-1,
      idTipoMovimiento: -1,
      cantidad:0,
      idTrabajoOrden:-1,
      idTrabajoOrdenDetalle:-1,
      idsTrabajoOrdenDetalle: [],
      unidad:"",
      fechaRecepcion:null,
      fechaIngreso:null,
      idAlmacen: -1,
      proveedores:[],
      elementos:[],
      idMaquina:-1,
      idOperador:-1,
      salidas:[],
      reintegros:[],
      desgloses:[], //añadido pal desglose
      descripcion:"",
      tipoSalida:-1,
      idCliente: -1,      
      idAlmacenDestino: -1,
      idSubalmacenDestino: null,
      lote: "",
      idArticuloTipo: -1
    },
    headersElementos:[//Encabezados de la tabla de elementos
      {
        text: 'Número de Envases (Obligatorio)',
        value: 'multiplicar',
        align:'center',
        width:'30%',
        sortable: false,
      },
      {
        text: 'Volumen del Envase (Obligatorio)',
        value: 'cantidad',
        align:'center',
        width:'30%',
        sortable: false,
      },
      {
        text: 'Folio (Opcional)',
        value: 'Folio',
        align:'center',
        width:'30%',
        sortable: false,
      },
      {
        text: 'Lote (Opcional)',
        value: 'lote',
        align:'center',
        width:'30%',
        sortable: false,
      },
      {
        text: 'Acciones',
        value: 'actions',
        align:'center',
        width:'10%',
        sortable: false,
      },
    ],
    elementoDefault:{
      numElemento: -1,
      multiplicar: 1,
      cantidad: 1,
      Folio:"",
      lote: null
    },
    headersProveedores:[
      {
        text: 'Tipo de Proveedor (Obligatorio)',
        value: 'tipoProveedor',
        align: 'center',
        width: '40%',
        sortable: false,
      },
      {
        text: 'Proveedor (Obligatorio)',
        value: 'proveedor',
        align: 'center',
        width: '40%',
        sortable: false,
      },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        width: '20%',
        sortable: false,
      }
    ],
    headersVentasPublico:[
      {
        text: 'Clave',
        value: 'codigo',
        align: 'center',
      },
      {
        text: 'Almacén',
        value: 'almacen',
        align: 'center',
      },
      {
        text: 'Subalmacén',
        value: 'subalmacen',
        align: 'center',
      },
      {
        text: 'Artículo',
        value: 'articulo',
        align: 'center',
      },
      {
        text: 'Detalles',
        value: 'detalles',
        align: 'center',
      },
      {
        text: 'Cantidad Requerida',
        value: 'cantidadRequerida',
        align: 'center',
      },
      {
        text: 'Cantidad',
        value: 'cantidad',
        align: 'center',
      },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
      }
    ],
    headersSalidasCliente:[
      {
        text: 'Clave',
        value: 'codigo',
        align: 'center',
      },
      {
        text: 'Almacén',
        value: 'almacen',
        align: 'center',
      },
      {
        text: 'Subalmacén',
        value: 'subalmacen',
        align: 'center',
      },
      {
        text: 'Cantidad',
        value: 'cantidad',
        align: 'center',
      },
      {
        text: 'Artículo',
        value: 'articulo',
        align: 'center',
      },
      {
        text: 'Detalles',
        value: 'detalles',
        align: 'center',
      },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
      }
    ],
    headersSalidas:[
      {
        text: 'Clave',
        value: 'codigo',
        align: 'center',
      },
      {
        text: 'Almacén',
        value: 'almacen',
        align: 'center',
      },
      {
        text: 'Subalmacén',
        value: 'subalmacen',
        align: 'center',
      },
      {
        text: 'Artículo',
        value: 'articulo',
        align: 'center',
      },
      {
        text: 'Detalles',
        value: 'detalles',
        align: 'center',
      },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
      }
    ],
    headersSalidasAAlmacen:[
      {
        text: 'Clave',
        value: 'codigo',
        align: 'center',
      },
      {
        text: 'Almacén',
        value: 'almacen',
        align: 'center',
      },
      {
        text: 'Subalmacén',
        value: 'subalmacen',
        align: 'center',
      },
      {
        text: 'Almacén destino',
        value: 'almacenDestino',
        align: 'center',
      },
      {
        text: 'Subalmacén destino',
        value: 'subalmacenDestino',
        align: 'center',
      },
      {
        text: 'Artículo',
        value: 'articulo',
        align: 'center',
      },
      {
        text: 'Detalles',
        value: 'detalles',
        align: 'center',
      },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
      }
    ],
    headersReintegros:[
      {
        text: '#',
        value: 'indice',
        align: 'center',
        width: "5%",
        sortable: false,
      },
      {
        text: 'Clave',
        value: 'codigo',
        align: 'center',
      },
      {
        text: 'Almacén',
        value: 'almacen',
        align: 'center',
      },
      {
        text: 'Subalmacén',
        value: 'subalmacen',
        align: 'center',
      },
      {
        text: 'Artículo',
        value: 'articulo',
        align: 'center',
      },
      {
        text: 'Cantidad',
        value: 'cantidad',
        align: 'center',
      },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
      },
      { 
        text: 'Desglosar',
        width: "5%",
        align: 'center',
        value: 'data-table-expand' 
      },
    ],
    proveedorTipos:[],
    listaProveedores:[],
    proveedorDefault:{
      idProveedorTipo:-1,
      idProveedor: -1,
    },
    checkOptions: {
      animationData: checkData.default,
      loop:false,
      speeed: 0.5
    },
    operadores:[],
    maquinas:[],
    soundBeep:null,
    soundError:null,
    lecturasRemotas:[],
    loadingLecturasRemotas: false,
    selectCode: null,
    dialogDesglosar: false, //De aquí
    desgloses: [],
    payloadDesglosar: [],
    obj: null,
    sinDesglosar: [],
    totality: 0,
		errores: [],
		porcentajes: [],
    cantidades: [],
    fechaNow: moment().format("yyyy-MM-DD HH:mm"),
    desglosarPayload: [],
		porcentajesValidos: false,
		cantidadesValidos: false,
		loadingHistorial: false,
    savingDesglosar: false,
    loading: false,
    dialogHistorial: false,
    cantidadFaltante: 0,
    movimientoDesglose: [
			{
				idMovimientoDetalle: 0,
				cantidadFaltante: 0,
				payload: [],
        unidad:"",
			},
		],
    defaultmovimientoDesglose: [
			{
				idMovimientoDetalle: 0,
				cantidadFaltante: 0,
				payload: [],
        unidad:"",
			},
		],  
    headersDesglose: [
			{
				text: "Tipo",
				align: "center",
				sort: false,
				value: "mantenimientoTipo",
			},
			{
				text: "Código",
				align: "center",
				sort: false,
				value: "mantenimientoCodigo",
			},
			{
				text: "Nombre",
				align: "center",
				sort: false,
				value: "mantenimiento",
			},
			{
				text: "Inicio",
				align: "center",
				sort: false,
				value: "inicioRealizo",
			},
			{
				text: "Termino",
				align: "center",
				sort: false,
				value: "finRealizo",
			},
			{
				text: "Máquina",
				align: "center",
				sort: false,
				value: "maquina",
			},
			{
				text: "Máquina Instancia",
				align: "center",
				sort: false,
				value: "maquinaIns",
			},
			{
				text: "Cantidad",
				align: "center",
				sort: false,
				value: "cantidad",
			},
			{
				text: "Porcentaje",
				align: "center",
				sort: false,
				value: "porcentaje",
			},
		],
    numberRule: (num) => {
			if (!isNaN(parseFloat(num)) && num > 0 && num <= 100) return true;
			return "Invalido.";
		}, 
    cantidadRule: (num) => {
			if (!isNaN(parseFloat(num)) && num > 0) return true;
			return "Invalido.";
		},//Hasta aquí es lo nuevo del desglose
  }),
  created () {
    this.initialize();
    if(!this.permisoVista('movimientos-sindesglosar', '$')) this.headersSinDesglosar = this.headersSinDesglosar.filter(x => x.value != 'costoUnitario' && x.value != 'costoTotal');
  },
  computed:{
    subalmacenesComputed(){
      if(this.movimientoItem.idAlmacen == null) return [];
      return this.subalmacenes.filter( subalmacen => subalmacen.idAlmacen == this.movimientoItem.idAlmacen);
    },
    articulosOrdenVenta(){
      const articulos = [];
      this.ordenesVentaPublico.forEach( venta => {
        if(venta.idPublicoVenta == this.movimientoItem.idPublicoVenta){
          articulos.push(...venta.articulos);
        }
      });
      return articulos;
    },
    movimientoItemSalidas(){
      return this.movimientoItem.salidas;
    },
    tiposSalidas(){
      var tipos = [];
      if(this.movimientoItem.idTipoMovimiento == 1){
        tipos.push({
          idTipoSalida:1,
          nombre: "A Producción",
        },{
          idTipoSalida:2,
          nombre: "A Cliente",
        },{
            idTipoSalida:4,
            nombre: "A Proveedor",
          },{
            idTipoSalida:5,
            nombre: "Venta al Público",
          },{
            idTipoSalida:7,
            nombre: "Producción a Almacén",
          }
        );
      }
      else{
        tipos.push({
          idTipoSalida:1,
          nombre: "A Producción",
        },{
          idTipoSalida:4,
          nombre: "A Proveedor",
        });
      }
      
      return tipos;
    },
    esSalidaAAlmacen(){
      return (this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6) && this.movimientoItem.tipoSalida == 6;
    },
    esIngresoProduccion(){
      return (this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6) && this.movimientoItem.tipoSalida == 7;
    },
    esProduccionSinQr(){
      return this.movimientoItem.idTipoMovimiento == 1 && this.movimientoItem.tipoSalida == 1 && this.sinQrProduccion;
    },
    puedeAgregarSinQr(){
      return this.esProduccionSinQr
        && this.sinQrItem.idAlmacen > 0
        && this.sinQrItem.idArticulo > 0
        && parseFloat(this.sinQrItem.cantidad) > 0;
    },
    // Solo materia prima (idArticuloTipo == 1) para la salida sin QR a producción.
    materiasPrimas(){
      return (this.articulosCatalogoRaw || []).filter(articulo => articulo.idArticuloTipo == 1);
    },
    headersTablaSalidas(){
      if(this.movimientoItem.idTipoMovimiento == 1){
        // Folio nuevo en salida parcial DESACTIVADO a solicitud (arrastra folio original). Código conservado:
        // if(this.movimientoItem.tipoSalida == 1) return this.editarCantidadSalida ? this.headersSalidasConFolioNuevo : this.headersSalidasCliente;
        if(this.movimientoItem.tipoSalida == 1) return this.headersSalidasCliente;
        if(this.movimientoItem.tipoSalida == 2 || this.movimientoItem.tipoSalida == 3 || this.movimientoItem.tipoSalida == 4) return this.headersSalidasCliente;
        if(this.movimientoItem.tipoSalida == 5) return this.headersVentasPublico;
        if(this.movimientoItem.tipoSalida == 6) return this.headersSalidasAAlmacen;
        return this.headersSalidas;
      }
      if(this.movimientoItem.idTipoMovimiento == 6){
        if(this.movimientoItem.tipoSalida == 2) return this.headersSalidas;
        if(this.movimientoItem.tipoSalida == 6) return this.headersSalidasAAlmacen;
        return this.headersSalidasCliente;
      }
      return this.headersSalidas;
    },
    // Folio nuevo en salida parcial DESACTIVADO a solicitud (arrastra folio original). Código conservado:
    // headersSalidasConFolioNuevo(){
    //   const base = this.headersSalidasCliente.slice();
    //   const col = { text: 'Folio nuevo', value: 'folioNuevo', align: 'center', sortable: false };
    //   const idxAcciones = base.findIndex(h => h.value === 'actions');
    //   if(idxAcciones >= 0) base.splice(idxAcciones, 0, col);
    //   else base.push(col);
    //   return base;
    // },
    almacenDestinoSalidaTexto(){
      const almacenDestino = this.almacenes.find(item => item.idAlmacen == this.movimientoItem.idAlmacenDestino);
      return almacenDestino ? this.almacenUbicacionText(almacenDestino) : "N/A";
    },
    subalmacenesDestinoSalida(){
      if(!(this.movimientoItem.idAlmacenDestino > 0)) return [];
      return this.subalmacenes.filter(item => item.idAlmacen == this.movimientoItem.idAlmacenDestino);
    },
    requiereSubalmacenDestinoSalida(){
      return this.esSalidaAAlmacen && this.subalmacenesDestinoSalida.length > 0;
    },
    subalmacenDestinoSalidaTexto(){
      if(!(this.movimientoItem.idAlmacenDestino > 0)) return "N/A";
      if(!this.requiereSubalmacenDestinoSalida) return "N/A";
      const subalmacen = this.subalmacenes.find(item => item.idSubalmacen == this.movimientoItem.idSubalmacenDestino);
      return subalmacen ? this.nombreSubalmacen(subalmacen) : "N/A";
    },
    puedeAgregarArticuloSalidaAlmacen(){
      if(!this.esSalidaAAlmacen) return false;
      if(!(this.movimientoItem.idAlmacenDestino > 0)) return false;
      if(!this.articuloSalidaAlmacenKey) return false;
      if(this.requiereSubalmacenDestinoSalida && this.movimientoItem.idSubalmacenDestino == null) return false;
      return true;
    },
    usaCapturaCodigoQR(){
      const aplicaCapturaQr = (this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6) || this.movimientoItem.idTipoMovimiento == 4;
      return aplicaCapturaQr && !this.esSalidaAAlmacen && !this.esIngresoProduccion && !this.esProduccionSinQr;
    },
    almacenesDestinoSalida(){
      if(this.movimientoItem.salidas.length == 0) return this.almacenes;
      const idsOrigen = [...new Set(
        this.movimientoItem.salidas
          .map(item => this.obtenerIdAlmacenMovimiento(item))
          .filter(id => id != null)
      )];
      if(idsOrigen.length == 0) return this.almacenes;
      return this.almacenes.filter(item => idsOrigen.indexOf(item.idAlmacen) == -1);
    },
    articulosDisponiblesSalidaAlmacen(){
      if(!this.esSalidaAAlmacen) return [];
      if(!(this.movimientoItem.idAlmacenDestino > 0)) return [];

      const idAlmacenDestino = this.movimientoItem.idAlmacenDestino;
      const opciones = new Map();
      const normalizarSubalmacenTexto = (valor) => {
        const txt = (valor || "").toString().trim();
        if(!txt) return "N/A";
        if(txt.toLowerCase() == "n/a") return "N/A";
        return txt;
      };
      const yaAgregados = new Set(
        this.movimientoItem.salidas.map(item => {
          const idAlmacen = this.obtenerIdAlmacenMovimiento(item);
          const idSubalmacen = this.obtenerIdSubalmacenMovimiento(item);
          const idArticulo = this.obtenerIdArticuloMovimiento(item);
          return `${idAlmacen}|${idSubalmacen == null ? "null" : idSubalmacen}|${idArticulo}`;
        })
      );

      const agregarOpcion = ({ idAlmacen, idSubalmacen, idArticulo, codigo, nombre, subalmacenTexto }) => {
        if(idAlmacen == null || idArticulo == null) return;
        if(idAlmacen == idAlmacenDestino) return;

        const key = `${idAlmacen}|${idSubalmacen == null ? "null" : idSubalmacen}|${idArticulo}`;
        const subalmacenNormalizado = normalizarSubalmacenTexto(subalmacenTexto);
        if(yaAgregados.has(key) || opciones.has(key)) return;

        const almacenObj = this.almacenes.find(item => item.idAlmacen == idAlmacen);
        const codigoArticulo = (codigo || "").toString().trim();
        const nombreArticulo = (nombre || `Artículo ${idArticulo}`).toString().trim();

        opciones.set(key, {
          key,
          idAlmacen,
          idSubalmacen: idSubalmacen == null ? null : idSubalmacen,
          idArticulo,
          codigo: codigoArticulo,
          nombre: nombreArticulo,
          articulo: codigoArticulo ? `[${codigoArticulo}] - ${nombreArticulo}` : nombreArticulo,
          almacen: almacenObj ? this.almacenText(almacenObj) : `Almacén ${idAlmacen}`,
          subalmacen: subalmacenNormalizado
        });
      };

      this.articulosSinQr.forEach(item => {
        let idArticulo = this.obtenerIdArticuloSinQr(item);
        const codigo = item.codigo || item.Codigo || "";
        const idSubalmacen = this.obtenerIdSubalmacenSinQr(item);
        const subalmacenObj = idSubalmacen == null ? null : this.subalmacenes.find(sub => sub.idSubalmacen == idSubalmacen);
        const subalmacenTexto =
          (subalmacenObj ? this.nombreSubalmacen(subalmacenObj) : null) ||
          this.obtenerPropiedadValida(item, ["subalmacen", "Subalmacen", "nombreSubalmacen", "NombreSubalmacen", "subAlmacen", "SubAlmacen"]) ||
          "N/A";
        if(idArticulo == null) idArticulo = this.obtenerIdArticuloPorCodigo(codigo);

        agregarOpcion({
          idAlmacen: this.obtenerIdAlmacenSinQr(item),
          idSubalmacen,
          idArticulo,
          codigo,
          nombre: item.nombre || item.Nombre,
          subalmacenTexto
        });
      });

      this.movimientosEntradasGenerales.forEach(item => {
        let idAlmacen = this.obtenerIdAlmacenMovimiento(item);
        if(idAlmacen == null) idAlmacen = this.obtenerIdAlmacenPorTexto(item.almacen || item.Almacen || "");

        const codigoArticulo = item.codigoArticulo || item.CodigoArticulo || this.obtenerCodigoDesdeTexto(item.articulo || item.Articulo || "");
        let idArticulo = this.obtenerIdArticuloMovimiento(item);
        if(idArticulo == null) idArticulo = this.obtenerIdArticuloPorCodigo(codigoArticulo);
        let idSubalmacen = this.obtenerIdSubalmacenMovimiento(item);
        if(idSubalmacen == null){
          idSubalmacen = this.obtenerIdSubalmacenPorTexto(item.subalmacen || item.Subalmacen || "", idAlmacen);
        }
        const subalmacenObj = idSubalmacen == null ? null : this.subalmacenes.find(sub => sub.idSubalmacen == idSubalmacen);
        const subalmacenTexto =
          (subalmacenObj ? this.nombreSubalmacen(subalmacenObj) : null) ||
          item.subalmacen ||
          item.Subalmacen ||
          "N/A";

        const nombreArticulo = (item.articulo || item.Articulo || "").toString().replace(/^\s*\[[^\]]+\]\s*-\s*/,"").trim();
        agregarOpcion({
          idAlmacen,
          idSubalmacen,
          idArticulo,
          codigo: codigoArticulo,
          nombre: nombreArticulo,
          subalmacenTexto
        });
      });

      return Array.from(opciones.values()).sort((a,b) => {
        const txtA = `${a.articulo} ${a.almacen} ${a.subalmacen}`.toLowerCase();
        const txtB = `${b.articulo} ${b.almacen} ${b.subalmacen}`.toLowerCase();
        if(txtA < txtB) return -1;
        if(txtA > txtB) return 1;
        return 0;
      });
    },
    salidasMantenimiento(){
      if(this.movimientoItem.salidas.length == 0) return false;
      return (this.movimientoItem.salidas.filter(a => a.produccion == false && a.receta == false).length > 0);
    },
    salidasProduccion(){
      if(this.movimientoItem.salidas.length == 0) return false;
      return (this.movimientoItem.salidas.filter(a => a.produccion == true).length > 0);
    },
    salidasReceta(){
      if(this.movimientoItem.salidas.length == 0) return false;
      return (this.movimientoItem.salidas.filter(a => a.receta == true).length > 0);
    },
    tipoMovimientosMov(){
      return this.tipoMovimientos.filter(element => {
        return element.idTipoMovimiento != 3 && element.idTipoMovimiento != 6
      });
    },
    almacenesConInventarioUbicacion() {
      return this.almacenes;
    },
    articulosDisponiblesUbicacion() {
      if (this.movimientoUbicacionItem.idAlmacen == null) return [];
      if (this.loadingMovimientosUbicacion || this.loadingSaldosArticulosUbicacion) return [];

      const idAlmacenSeleccionado = this.movimientoUbicacionItem.idAlmacen;
      const saldosFallback = this.calcularSaldosArticuloDesdeMovimientos(idAlmacenSeleccionado);
      const saldosApi = this.saldosArticulosUbicacionApi || {};
      const saldosBase = {};
      const keys = new Set([
        ...Object.keys(saldosApi),
        ...Object.keys(saldosFallback || {})
      ]);
      keys.forEach(key => {
        const saldoApi = Number(saldosApi[key] || 0);
        const saldoFallback = Number((saldosFallback || {})[key] || 0);
        const saldo = Math.max(saldoApi, saldoFallback);
        if (saldo > 0) saldosBase[key] = saldo;
      });
      const idsArticulosConSaldo = new Set(
        Object.keys(saldosBase || {})
          .filter(key => Number(saldosBase[key]) > 0)
          .map(key => Number(key))
          .filter(id => Number.isFinite(id))
      );
      if (idsArticulosConSaldo.size == 0) return [];

      const articulosMap = new Map();

      this.articulosSinQr
        .filter(item => this.obtenerIdAlmacenSinQr(item) == idAlmacenSeleccionado)
        .forEach(item => {
          const idArticulo = this.obtenerIdArticuloSinQr(item);
          if (idArticulo == null || articulosMap.has(idArticulo)) return;
          if (!idsArticulosConSaldo.has(Number(idArticulo))) return;
          articulosMap.set(idArticulo, {
            idArticulo,
            codigo: item.codigo || item.Codigo || "",
            nombre: item.nombre || item.Nombre || `Artículo ${idArticulo}`
          });
        });

      this.movimientosEntradasAlmacen
        .forEach(item => {
          const codigo = item.codigoArticulo || item.CodigoArticulo || this.obtenerCodigoDesdeTexto(item.articulo || item.Articulo || "");
          let idArticulo = this.obtenerIdArticuloMovimiento(item);
          if (idArticulo == null && codigo) {
            idArticulo = this.obtenerIdArticuloPorCodigo(codigo);
          }
          if (idArticulo == null) return;
          if (!idsArticulosConSaldo.has(Number(idArticulo))) return;
          if (articulosMap.has(idArticulo)) return;
          articulosMap.set(idArticulo, {
            idArticulo,
            codigo: codigo || "",
            nombre: item.articulo || item.Articulo || `Artículo ${idArticulo}`
          });
        });

      if (articulosMap.size == 0) {
        idsArticulosConSaldo.forEach(idArticulo => {
          const articulo = this.articulos.find(item => item.idArticulo == idArticulo);
          if (!articulo || articulosMap.has(idArticulo)) return;
          articulosMap.set(idArticulo, {
            idArticulo,
            codigo: articulo.codigo || "",
            nombre: articulo.nombre || `Artículo ${idArticulo}`
          });
        });
      }

      return Array.from(articulosMap.values()).sort((a, b) => {
        const txtA = `${a.codigo || ""} ${a.nombre || ""}`.toLowerCase();
        const txtB = `${b.codigo || ""} ${b.nombre || ""}`.toLowerCase();
        if (txtA < txtB) return -1;
        if (txtA > txtB) return 1;
        return 0;
      });
    },
    subalmacenesOrigenUbicacion() {
      if (this.movimientoUbicacionItem.idAlmacen == null || this.movimientoUbicacionItem.idArticulo == null) return [];
      const subalmacenes = this.subalmacenes
        .filter(sub => sub.idAlmacen == this.movimientoUbicacionItem.idAlmacen)
        .filter(sub => Number(this.saldosSubalmacenUbicacion[String(sub.idSubalmacen)] || 0) > 0);

      if (this.sinSubalmacenDisponibleUbicacion) {
        subalmacenes.unshift({
          idSubalmacen: -1,
          clave: "SIN",
          subalmacen: "Sin subalmacén asignado (agregar a subalmacén)"
        });
      }
      return subalmacenes;
    },
    subalmacenesDestinoUbicacion() {
      if (this.movimientoUbicacionItem.idAlmacen == null) return [];
      return this.subalmacenes
        .filter(sub => sub.idAlmacen == this.movimientoUbicacionItem.idAlmacen)
        .filter(sub => sub.idSubalmacen != this.movimientoUbicacionItem.idSubalmacenOrigen);
    },
    puedeAgregarMovimientoUbicacion() {
      if (this.movimientoItem.idTipoMovimiento != 7) return false;
      if (this.movimientoUbicacionItem.idAlmacen == null) return false;
      if (this.movimientoUbicacionItem.idArticulo == null) return false;
      if (this.movimientoUbicacionItem.idSubalmacenOrigen == null) return false;
      if (this.movimientoUbicacionItem.idSubalmacenDestino == null) return false;
      if (this.movimientoUbicacionItem.idSubalmacenOrigen == this.movimientoUbicacionItem.idSubalmacenDestino) return false;
      if (this.infoArticuloUbicacion == null) return false;
      const disponible = parseFloat((this.infoArticuloUbicacion && this.infoArticuloUbicacion.maximo) || 0);
      if (disponible <= 0) return false;
      const cantidad = parseFloat(this.movimientoUbicacionItem.cantidad);
      if (isNaN(cantidad) || cantidad <= 0) return false;
      if (cantidad > disponible) return false;
      return true;
    },

    totalElementos(){
      if(this.movimientoItem.elementos.length == 0) return 0;
      var cantidad = 0.0;
      this.movimientoItem.elementos.forEach(element => {
        if(!isNaN(parseFloat(element.multiplicar)) && !isNaN(parseFloat(element.cantidad))){
          cantidad += parseFloat(element.multiplicar) * parseFloat(element.cantidad);
        }
      });
      return cantidad;
    },
    ...mapState({
      nombreEmpresa: 'nombreEmpresa',
      idUser: 'idUser',
      token: 'token',
      salidasQR: 'salidasQR',
      recuperarDatos:"recuperarDatos"
    }),
    apiBase(){
      const base = axios.defaults.baseURL || "/api";
      return base.endsWith("/") ? base.slice(0, -1) : base;
    },
  },
  watch:{
    show(val){
      if(val){
        this.reset();
        this.showWizard = false;
        this.tipoMovimientoSelectKey++;
        this.initialize();
      } else {
        this.showWizard = false;
      }
    },
    movimientoItemSalidas(){
      if(this.esProduccionSinQr) return;
      if(this.movimientoItem.tipoSalida == 6 && this.movimientoItem.idAlmacenDestino > 0){
        const existe = this.almacenesDestinoSalida.find(item => item.idAlmacen == this.movimientoItem.idAlmacenDestino);
        if(!existe) this.movimientoItem.idAlmacenDestino = -1;
      }
      if(this.movimientoItem.tipoSalida == 5 || this.movimientoItem.tipoSalida == 6) return;
      if(this.movimientoItem.salidas.length == 0){
        this.movimientoItem.tipoSalida = -1;
      }
    },
    cantidades() {
			if (this.movimientoDesglose !== undefined) {
				if (this.movimientoDesglose.payload !== undefined) {
					this.validarCantidades();
				}
			}
		},
  },
  methods:{
    buildApiUrl(path){
      const normalizedPath = path.startsWith("/") ? path : `/${path}`;
      if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath;
      return `${this.apiBase}${normalizedPath}`;
    },
    obtenerNombreArchivoQr(fichero){
      if(!fichero) return "";
      return String(fichero).split(/[\\/]/).pop();
    },
    descargarQRCodigosGuardado(){
      const fileName = this.obtenerNombreArchivoQr(this.qrPdf);
      if(!fileName){
        this.$notify({
          group: 'inventario',
          title: 'No se encontró el archivo de etiquetas para descargar',
          type: 'error',
        });
        return;
      }
      const url = this.buildApiUrl(`/Inventario/DescargarQR/${encodeURIComponent(fileName)}`) + `?access_token=${this.token}`;
      window.open(url, "_blank");
    },
    nombreSubalmacen: ({ clave, subalmacen }) => `[${clave}] - ${subalmacen}`.trim(),
    nombreArticulo: (value) => value.codigo!=null?`[${value.codigo}] - ${value.nombre}`:`${value.nombre}`,
    articuloSalidaAlmacenText(item){
      if(!item) return "";
      return `${item.articulo} | ${item.almacen} | ${item.subalmacen}`;
    },
    almacenUbicacionText(item) {
      const codigo = item && item.codigo ? `[${item.codigo}]` : `[${item.idAlmacen || "N/A"}]`;
      const nombre = item && item.nombre ? item.nombre : "N/A";
      return `${codigo} - ${nombre}`.trim();
    },
    obtenerPropiedadValida(objeto, campos = []) {
      for (let i = 0; i < campos.length; i++) {
        const campo = campos[i];
        if (Object.prototype.hasOwnProperty.call(objeto, campo) && objeto[campo] !== null && objeto[campo] !== undefined && objeto[campo] !== "") {
          return objeto[campo];
        }
      }
      return null;
    },
    obtenerIdAlmacenSinQr(item) {
      return this.obtenerPropiedadValida(item, ["idAlmacen", "IdAlmacen", "IDAlmacen", "id_almacen"]);
    },
    obtenerIdArticuloSinQr(item) {
      return this.obtenerPropiedadValida(item, ["idArticulo", "IdArticulo", "IDArticulo", "id_articulo"]);
    },
    obtenerIdSubalmacenSinQr(item) {
      return this.obtenerPropiedadValida(item, ["idSubalmacen", "IdSubalmacen", "IDSubalmacen", "IdSubAlmacen", "idSubAlmacen", "id_subalmacen"]);
    },
    obtenerIdAlmacenMovimiento(item) {
      return this.obtenerPropiedadValida(item, ["idAlmacen", "IdAlmacen", "IDAlmacen"]);
    },
    obtenerIdArticuloMovimiento(item) {
      return this.obtenerPropiedadValida(item, ["idArticulo", "IdArticulo", "IDArticulo"]);
    },
    obtenerIdSubalmacenMovimiento(item) {
      return this.obtenerPropiedadValida(item, ["idSubalmacen", "IdSubalmacen", "IDSubalmacen", "IdSubAlmacen"]);
    },
    obtenerCodigoDesdeTexto(texto) {
      const txt = (texto || "").toString();
      const match = txt.match(/\[([^\]]+)\]/);
      return match && match[1] ? match[1].trim() : null;
    },
    obtenerClaveSubalmacen(texto) {
      const txt = (texto || "").toString();
      const match = txt.match(/\[([^\]]+)\]/);
      return match && match[1] ? match[1].trim() : null;
    },
    normalizarCodigo(valor) {
      let contenido = (valor == null ? "" : valor).toString().trim();
      if (!contenido) return "";

      if (contenido.startsWith("{")) {
        try {
          const payload = JSON.parse(contenido);
          const codigoJson = payload?.codigo ?? payload?.Codigo ?? payload?.code ?? payload?.Code;
          if (codigoJson != null) contenido = codigoJson.toString();
        } catch (e) {
          // Mantener compatibilidad con códigos planos
        }
      }

      return contenido.replace(/-/g, "").trim().toUpperCase();
    },
    fromBase36(valor) {
      const txt = (valor || "").toString().trim().toUpperCase();
      if (!/^[0-9A-Z]+$/.test(txt)) return null;
      const numero = parseInt(txt, 36);
      return Number.isNaN(numero) ? null : numero;
    },
    decodificarCodigoRecepcionLogistica(codigo) {
      const normalizado = this.normalizarCodigo(codigo);
      if (!/^L[0-9A-Z]{8}$/.test(normalizado)) return null;

      const idRecepcionLogisticaArticulo = this.fromBase36(normalizado.substring(1, 7));
      const indiceEtiqueta = this.fromBase36(normalizado.substring(7, 9));

      if (!(idRecepcionLogisticaArticulo > 0) || !(indiceEtiqueta > 0)) return null;
      return {
        idRecepcionLogisticaArticulo,
        indiceEtiqueta
      };
    },
    obtenerIdAlmacenPorTexto(texto) {
      const codigo = this.obtenerCodigoDesdeTexto(texto);
      if (!codigo) return null;
      const almacen = this.almacenes.find(a =>
        String(a.codigo || "").trim().toUpperCase() === String(codigo).trim().toUpperCase()
      );
      return almacen ? almacen.idAlmacen : null;
    },
    obtenerIdSubalmacenPorTexto(texto, idAlmacen = null) {
      const clave = this.obtenerClaveSubalmacen(texto);
      if (!clave) return null;
      const subalmacen = this.subalmacenes.find(s =>
        (idAlmacen == null || s.idAlmacen == idAlmacen) &&
        String(s.clave || "").trim().toUpperCase() === String(clave).trim().toUpperCase()
      );
      return subalmacen ? subalmacen.idSubalmacen : null;
    },
    obtenerIdArticuloPorCodigo(codigo) {
      if (!codigo) return null;
      const articuloRaw = this.articulosCatalogoRaw.find(
        item => item && item.idArticulo != null && String(item.codigo || "").trim() === String(codigo).trim()
      );
      if (articuloRaw) return articuloRaw.idArticulo;

      const articulo = this.articulos.find(
        item => item && item.idArticulo != null && String(item.codigo || "").trim() === String(codigo).trim()
      );
      return articulo ? articulo.idArticulo : null;
    },
    obtenerCantidadMovimientoInventario(item) {
      const valor = this.obtenerPropiedadValida(item, ["cantidad", "Cantidad"]);
      if (valor == null) return 0;
      const limpio = String(valor)
        .replace(/\s+/g, "")
        .replace(/,/g, ".")
        .replace(/[^0-9.\-]/g, "");
      const cantidad = parseFloat(limpio);
      return Number.isFinite(cantidad) ? cantidad : 0;
    },
    obtenerIdArticuloMovimientoInventario(item) {
      let idArticulo = this.obtenerIdArticuloMovimiento(item);
      if (idArticulo != null) return idArticulo;
      const codigo = item.codigoArticulo || item.CodigoArticulo || this.obtenerCodigoDesdeTexto(item.articulo || item.Articulo || "");
      if (!codigo) return null;
      return this.obtenerIdArticuloPorCodigo(codigo);
    },
    obtenerIdSubalmacenMovimientoInventario(item, idAlmacen = null) {
      let idSubalmacen = this.obtenerIdSubalmacenMovimiento(item);
      if (idSubalmacen != null) return idSubalmacen;
      const subalmacenTexto = item.subalmacen || item.Subalmacen || "";
      idSubalmacen = this.obtenerIdSubalmacenPorTexto(subalmacenTexto, idAlmacen);
      if (idSubalmacen != null) return idSubalmacen;
      if (/sin subalmac|n\/a/i.test(String(subalmacenTexto))) return -1;
      return null;
    },
    calcularSaldosSubalmacenDesdeMovimientos(idAlmacen, idArticulo) {
      const saldos = {};
      this.movimientosEntradasAlmacen.forEach(item => {
        const idArticuloMov = this.obtenerIdArticuloMovimientoInventario(item);
        if (idArticuloMov == null || idArticuloMov != idArticulo) return;

        const idSubalmacen = this.obtenerIdSubalmacenMovimientoInventario(item, idAlmacen);
        if (idSubalmacen == null) return;

        const cantidad = this.obtenerCantidadMovimientoInventario(item);
        if (!Number.isFinite(cantidad) || cantidad === 0) return;

        const key = String(idSubalmacen);
        saldos[key] = Number(saldos[key] || 0) + cantidad;
      });

      const positivos = {};
      Object.keys(saldos).forEach(key => {
        if (Number(saldos[key]) > 0) positivos[key] = Number(saldos[key]);
      });
      return positivos;
    },
    calcularSaldosArticuloDesdeMovimientos(idAlmacen) {
      const saldos = {};
      this.movimientosEntradasAlmacen.forEach(item => {
        let idAlmacenMovimiento = this.obtenerIdAlmacenMovimiento(item);
        if (idAlmacenMovimiento == null) {
          idAlmacenMovimiento = this.obtenerIdAlmacenPorTexto(item.almacen || item.Almacen || "");
        }
        if (idAlmacenMovimiento != null && idAlmacenMovimiento != idAlmacen) return;

        const idArticulo = this.obtenerIdArticuloMovimientoInventario(item);
        if (idArticulo == null) return;

        const cantidad = this.obtenerCantidadMovimientoInventario(item);
        if (!Number.isFinite(cantidad) || cantidad === 0) return;

        const key = String(idArticulo);
        saldos[key] = Number(saldos[key] || 0) + cantidad;
      });
      return saldos;
    },
    async cargarSaldosArticulosUbicacion(idAlmacen) {
      this.saldosArticulosUbicacionApi = {};
      if (idAlmacen == null) return;

      const idsArticulos = new Set();

      this.articulosSinQr
        .filter(item => this.obtenerIdAlmacenSinQr(item) == idAlmacen)
        .forEach(item => {
          const idArticulo = this.obtenerIdArticuloSinQr(item);
          if (idArticulo != null) idsArticulos.add(Number(idArticulo));
        });

      this.movimientosEntradasAlmacen.forEach(item => {
        let idAlmacenMovimiento = this.obtenerIdAlmacenMovimiento(item);
        if (idAlmacenMovimiento == null) {
          idAlmacenMovimiento = this.obtenerIdAlmacenPorTexto(item.almacen || item.Almacen || "");
        }
        if (idAlmacenMovimiento != null && idAlmacenMovimiento != idAlmacen) return;

        const idArticulo = this.obtenerIdArticuloMovimientoInventario(item);
        if (idArticulo != null) idsArticulos.add(Number(idArticulo));
      });

      const idsValidos = Array.from(idsArticulos).filter(id => Number.isFinite(id) && id > 0);
      if (idsValidos.length == 0) return;

      const requestId = ++this.saldoArticuloRequestId;
      this.loadingSaldosArticulosUbicacion = true;
      try{
        const resultados = await Promise.all(
          idsValidos.map(async idArticulo => {
            const url = `/Inventario/InformacionBasicaSinQR?IdArticulo=${idArticulo}&IdAlmacen=${idAlmacen}`;
            try{
              const response = await axios.get(url);
              const data = response.data || {};
              const maximo = parseFloat(data.maximo || data.Maximo || 0);
              return [idArticulo, Number.isFinite(maximo) ? maximo : 0];
            }catch(error){
              return [idArticulo, 0];
            }
          })
        );
        if (requestId != this.saldoArticuloRequestId) return;

        const mapa = {};
        resultados.forEach(([idArticulo, maximo]) => {
          if (Number(maximo) > 0) mapa[String(idArticulo)] = Number(maximo);
        });
        this.saldosArticulosUbicacionApi = mapa;
      }finally{
        if (requestId == this.saldoArticuloRequestId) {
          this.loadingSaldosArticulosUbicacion = false;
        }
      }
    },
    obtenerSubalmacenOrigenPreferidoUbicacion(idAlmacen, idArticulo, mapaSaldos = {}) {
      const obtenerSaldo = (idSubalmacen) => Number(mapaSaldos[String(idSubalmacen)] || 0);

      const candidatosSinQr = this.articulosSinQr
        .filter(item =>
          this.obtenerIdAlmacenSinQr(item) == idAlmacen &&
          this.obtenerIdArticuloSinQr(item) == idArticulo
        )
        .map(item => this.obtenerIdSubalmacenSinQr(item))
        .filter(idSubalmacen => idSubalmacen != null)
        .filter((idSubalmacen, index, lista) => lista.indexOf(idSubalmacen) === index)
        .sort((a, b) => obtenerSaldo(b) - obtenerSaldo(a));

      const candidatoSinQr = candidatosSinQr.find(idSubalmacen => obtenerSaldo(idSubalmacen) > 0);
      if (candidatoSinQr != null) return candidatoSinQr;

      const candidatosConSaldo = this.subalmacenes
        .filter(sub => sub.idAlmacen == idAlmacen)
        .map(sub => ({ idSubalmacen: sub.idSubalmacen, saldo: obtenerSaldo(sub.idSubalmacen) }))
        .filter(item => item.saldo > 0)
        .sort((a, b) => b.saldo - a.saldo);

      if (candidatosConSaldo.length > 0) return candidatosConSaldo[0].idSubalmacen;
      if (obtenerSaldo(-1) > 0) return -1;
      return null;
    },
    // Reintegro de una tarima bifurcada (elemento nuevo de una salida parcial a producción).
    // El QR apunta al elemento nuevo, que no tiene movimiento tipo 1; se resuelve por endpoint dedicado.
    async intentarAgregarReintegroParcial(code){
      try{
        const response = await axios.get('/Inventario/InformacionReintegroSalidaParcial', { params: { Codigo: code } });
        const data = response.data;
        if(data == null) return false;
        data.cantidad = 0.0;
        data.msgDesgloses = [];
        data.esReintegroParcial = true;
        data.trabajoOrdenes.ordenesTrabajoDetalle = data.trabajoOrdenes.ordenesTrabajoDetalle != null
          ? data.trabajoOrdenes.ordenesTrabajoDetalle.map(odt => ({
              ...odt,
              idTrabajoOrden: data.trabajoOrdenes.idTrabajoOrden,
              cantidad: 0
            }))
          : [];
        this.movimientoItem.reintegros.push(data);
        return true;
      }catch(e){
        return false;
      }
    },
    async intentarAgregarSalidaDesdeLogistica(codigoEscaneado){
      try{
        const codigoBusqueda = this.normalizarCodigo(codigoEscaneado);
        if(!codigoBusqueda) return false;

        const dataCodigoLogistica = this.decodificarCodigoRecepcionLogistica(codigoBusqueda);
        if(dataCodigoLogistica != null){
          const repetido = this.movimientoItem.salidas.find(salida =>
            this.normalizarCodigo(salida.codigo) === codigoBusqueda
          );
          if(repetido) return true;

          try{
            const detalleResponse = await axios.get(`/Inventario/RecepcionLogisticaDetalle/${dataCodigoLogistica.idRecepcionLogisticaArticulo}`);
            const detalle = detalleResponse.data || {};
            const idArticulo = detalle.idArticulo || detalle.IdArticulo || null;
            const idAlmacen = detalle.idAlmacen || detalle.IdAlmacen || null;
            const idSubalmacen = (detalle.idSubalmacen === undefined ? detalle.IdSubalmacen : detalle.idSubalmacen);

            if(idArticulo != null && idAlmacen != null){
              let url = `/Inventario/InformacionBasicaSinQR?IdArticulo=${idArticulo}&IdAlmacen=${idAlmacen}`;
              if(idSubalmacen != null) url += `&IdSubalmacen=${idSubalmacen}`;

              const infoResponse = await axios.get(url);
              const info = infoResponse.data || {};
              const maximo = parseFloat(info.maximo || info.Maximo || 0);
              if(maximo > 0){
                this.movimientoItem.salidas.push({
                  codigo: codigoBusqueda,
                  idAlmacen,
                  idSubalmacen: idSubalmacen == null ? null : idSubalmacen,
                  idArticulo,
                  articulo: (detalle.codigoArticulo || detalle.CodigoArticulo)
                    ? `[${detalle.codigoArticulo || detalle.CodigoArticulo}] - ${detalle.articulo || detalle.Articulo || `Artículo ${idArticulo}`}`
                    : (detalle.articulo || detalle.Articulo || `Artículo ${idArticulo}`),
                  almacen: detalle.almacen || detalle.Almacen || "N/A",
                  subalmacen: detalle.subalmacen || detalle.Subalmacen || "N/A",
                  proveedores: [],
                  produccion: false,
                  receta: false,
                  maximo,
                  cantidad: 0,
                  abreviatura: info.abreviatura || info.Abreviatura || "",
                  enUso: false
                });

                return true;
              }
            }
          }
          catch(error){
            console.log(error);
          }
        }

        const response = await axios.get("/Inventario/Movimientos?TipoMovimiento=2");
        const movimientos = response.data || [];
        const movimiento = movimientos.find(item => {
          const articuloTexto = item.articulo || item.Articulo || "";
          const posibles = [
            item.codigo,
            item.Codigo,
            item.codigoArticulo,
            item.CodigoArticulo,
            this.obtenerCodigoDesdeTexto(articuloTexto),
          ];
          return posibles.some(valor => this.normalizarCodigo(valor) === codigoBusqueda);
        });

        if(!movimiento) return false;

        const codigoArticulo = (movimiento.codigoArticulo || movimiento.CodigoArticulo || this.obtenerCodigoDesdeTexto(movimiento.articulo || movimiento.Articulo || "") || "").toString().trim();
        const idArticulo = this.obtenerIdArticuloPorCodigo(codigoArticulo);
        const idAlmacen = this.obtenerIdAlmacenPorTexto(movimiento.almacen || movimiento.Almacen || "");
        const idSubalmacen = this.obtenerIdSubalmacenPorTexto(movimiento.subalmacen || movimiento.Subalmacen || "", idAlmacen);

        if(idArticulo == null || idAlmacen == null) return false;

        const repetido = this.movimientoItem.salidas.find(salida =>
          this.normalizarCodigo(salida.codigo) === codigoBusqueda
        );
        if(repetido) return true;

        let url = `/Inventario/InformacionBasicaSinQR?IdArticulo=${idArticulo}&IdAlmacen=${idAlmacen}`;
        if(idSubalmacen != null) url += `&IdSubalmacen=${idSubalmacen}`;

        const infoResponse = await axios.get(url);
        const info = infoResponse.data || {};
        const maximo = parseFloat(info.maximo || info.Maximo || 0);
        if(!(maximo > 0)) return false;

        const almacenObj = this.almacenes.find(a => a.idAlmacen == idAlmacen);
        const subalmacenObj = idSubalmacen == null ? null : this.subalmacenes.find(s => s.idSubalmacen == idSubalmacen);

        this.movimientoItem.salidas.push({
          codigo: codigoBusqueda,
          idAlmacen,
          idSubalmacen,
          idArticulo,
          articulo: movimiento.articulo || movimiento.Articulo || (codigoArticulo ? `[${codigoArticulo}]` : `Artículo ${idArticulo}`),
          almacen: movimiento.almacen || movimiento.Almacen || (almacenObj ? this.almacenText(almacenObj) : "N/A"),
          subalmacen: movimiento.subalmacen || movimiento.Subalmacen || (subalmacenObj ? this.nombreSubalmacen(subalmacenObj) : "N/A"),
          proveedores: [],
          produccion: false,
          receta: false,
          maximo,
          cantidad: 0,
          abreviatura: info.abreviatura || info.Abreviatura || "",
          enUso: false
        });

        return true;
      }
      catch(error){
        console.log(error);
        return false;
      }
    },
    changeAlmacen(){
      this.movimientoItem.idSubalmacen = null;
    },
    onSelectEntrada(val) {
      if (val === 2) {
        this.resetOT();
        this.reset();
        this.showWizard = true;
      } else {
        this.resetOT();
      }
    },
    onToggleEditarCantidadSalida(){
      // Al apagar el switch se vuelve a la cantidad completa de cada elemento.
      if(!this.editarCantidadSalida){
        this.movimientoItem.salidas.forEach(salida => {
          salida.cantidad = salida.maximo;
        });
      }
    },
    changeTipoSalida(){
      this.editarCantidadSalida = false;
      this.movimientoItem.idAlmacenDestino = -1;
      this.movimientoItem.idSubalmacenDestino = null;
      this.articuloSalidaAlmacenKey = null;
      if(this.movimientoItem.tipoSalida == 6){
        this.movimientoItem.idCliente = -1;
        this.movimientoItem.idPublicoVenta = null;
      }
      /* if(this.movimientoItem.tipoSalida == 5){
        this.erroresCantidades = [];
        this.movimientoItem.salidas = [];
        this.movimientoItem.idPublicoVenta = null;
        this.errorOrdenVenta = "Debe seleccionar una Orden de Venta";
      } */
      this.produccionDisponible = null;
      this.cantidadIngreso = 0;
      this.loadingProduccion = false;
      this.sinQrProduccion = false;
      this.sinQrItem = { idAlmacen: -1, idArticulo: -1, cantidad: undefined, maximo: null };
      this.salidasProduccionSinQr = [];
      this.movimientoItem.idTrabajoOrden = -1;
      this.movimientoItem.idTrabajoOrdenDetalle = -1;
    },
    onChangeOrdenProduccion(idTrabajoOrden){
      this.movimientoItem.idTrabajoOrdenDetalle = -1;
      this.produccionDisponible = null;
      this.cantidadIngreso = 0;
      this.setDetalles(idTrabajoOrden);
      if(this.trabajoOrdenDetalles.length == 1){
        this.movimientoItem.idTrabajoOrdenDetalle = this.trabajoOrdenDetalles[0].idTrabajoOrdenDetalle;
        this.onChangeDetalleProduccion();
      }
    },
    onChangeDetalleProduccion(){
      this.produccionDisponible = null;
      this.cantidadIngreso = 0;
      const idDetalle = parseInt(this.movimientoItem.idTrabajoOrdenDetalle, 10);
      if(!(idDetalle > 0)) return;
      this.getProduccionDisponible(idDetalle);
    },
    getProduccionDisponible(idTrabajoOrdenDetalle){
      this.loadingProduccion = true;
      axios
        .get('/Inventario/ProduccionDisponiblePorODT', {
          params: { idTrabajoOrdenDetalle }
        })
        .then(({ data }) => {
          this.produccionDisponible = data;
        })
        .catch(error => {
          this.produccionDisponible = null;
          this.soundError.play();
          this.$notify({
            group: 'inventario',
            title: 'No se pudo consultar la producción disponible',
            type: 'error',
          });
          console.log(error);
        })
        .finally(() => {
          this.loadingProduccion = false;
        });
    },
    saveIngresoProduccion(){
      const cantidad = parseFloat(this.cantidadIngreso);
      const disponible = this.produccionDisponible ? parseFloat(this.produccionDisponible.diferencia) : 0;

      if(this.movimientoItem.idTrabajoOrdenDetalle <= 0 || !this.produccionDisponible){
        this.saving = false;
        this.errores = ["Selecciona la orden de trabajo y el artículo a producir"];
        this.error = true;
        return;
      }
      if(this.movimientoItem.idAlmacenDestino <= 0){
        this.saving = false;
        this.errores = ["Selecciona el almacén destino"];
        this.error = true;
        return;
      }
      if(this.subalmacenesDestinoSalida.length > 0 && this.movimientoItem.idSubalmacenDestino == null){
        this.saving = false;
        this.errores = ["Selecciona el subalmacén destino"];
        this.error = true;
        return;
      }
      if(isNaN(cantidad) || cantidad <= 0){
        this.saving = false;
        this.errores = ["La cantidad a ingresar no es válida"];
        this.error = true;
        return;
      }
      if(cantidad > disponible){
        this.saving = false;
        this.errores = ["La cantidad supera lo disponible por enviar (" + this.formatoNumero(disponible) + ")"];
        this.error = true;
        return;
      }

      const payload = {
        idTrabajoOrdenDetalle: this.movimientoItem.idTrabajoOrdenDetalle,
        idAlmacenDestino: this.movimientoItem.idAlmacenDestino,
        idSubalmacenDestino: this.movimientoItem.idSubalmacenDestino,
        cantidad: cantidad
      };

      axios
        .post('/Inventario/IngresarProduccionAAlmacenQR', payload)
        .then((response) => {
          this.saving = false;
          if(response.data != null && response.data.length > 0){
            this.qrPdf = response.data;
            this.state = 1;
            return;
          }
          this.close(1);
        })
        .catch(error => {
          this.saving = false;
          const mensaje = (error && error.response && error.response.data && error.response.data.msg)
            ? error.response.data.msg
            : "No se pudo ingresar la producción al almacén";
          this.errores = [mensaje];
          this.error = true;
          console.log(error);
        });
    },
    formatoNumero(valor){
      const numero = Number(valor || 0);
      return numero.toLocaleString('es-MX', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4
      });
    },
    onToggleSinQrProduccion(){
      this.salidasProduccionSinQr = [];
      this.sinQrItem = { idAlmacen: -1, idArticulo: -1, cantidad: undefined, maximo: null };
      this.codigo = '';
    },
    async onChangeArticuloSinQr(){
      this.sinQrItem.maximo = null;
      await this.consultarStockSinQr();
    },
    async consultarStockSinQr(){
      if(!(this.sinQrItem.idArticulo > 0) || !(this.sinQrItem.idAlmacen > 0)){
        this.sinQrItem.maximo = null;
        return;
      }
      this.loadingSinQrStock = true;
      try{
        const { data } = await axios.get('/Inventario/InformacionBasicaSinQR', {
          params: {
            IdArticulo: this.sinQrItem.idArticulo,
            IdAlmacen: this.sinQrItem.idAlmacen
          }
        });
        const maximo = parseFloat((data && (data.maximo != null ? data.maximo : data.Maximo)) || 0);
        this.sinQrItem.maximo = isNaN(maximo) ? 0 : maximo;
      }catch(error){
        this.sinQrItem.maximo = 0;
        console.log(error);
      }finally{
        this.loadingSinQrStock = false;
      }
    },
    async agregarSalidaProduccionSinQr(){
      if(!this.puedeAgregarSinQr) return;
      const idAlmacen = this.sinQrItem.idAlmacen;
      const idArticulo = this.sinQrItem.idArticulo;
      const cantidad = parseFloat(this.sinQrItem.cantidad);

      await this.consultarStockSinQr();
      const disponible = parseFloat(this.sinQrItem.maximo || 0);

      if(!(disponible > 0)){
        this.soundError.play();
        this.$notify({ group: 'inventario', title: 'La materia prima no tiene stock disponible en ese almacén', type: 'error' });
        return;
      }
      if(cantidad > disponible){
        this.soundError.play();
        this.$notify({ group: 'inventario', title: 'La cantidad supera el stock disponible (' + disponible + ')', type: 'error' });
        return;
      }

      const repetido = this.salidasProduccionSinQr.find(s => s.idArticulo == idArticulo && s.idAlmacen == idAlmacen);
      if(repetido){
        this.soundError.play();
        this.$notify({ group: 'inventario', title: 'Esa materia prima ya fue agregada para ese almacén', type: 'error' });
        return;
      }

      const almacenObj = this.almacenes.find(a => a.idAlmacen == idAlmacen);
      const articuloObj = this.articulos.find(a => a.idArticulo == idArticulo);

      this.salidasProduccionSinQr.push({
        idArticulo,
        idAlmacen,
        cantidad,
        almacen: almacenObj ? this.almacenText(almacenObj) : ('Almacén ' + idAlmacen),
        articulo: articuloObj ? this.nombreArticulo(articuloObj) : ('Artículo ' + idArticulo)
      });

      this.sinQrItem = { idAlmacen: -1, idArticulo: -1, cantidad: undefined, maximo: null };
      this.sinQrCantidadKey++;
    },
    eliminarSalidaProduccionSinQr(item){
      const idx = this.salidasProduccionSinQr.indexOf(item);
      if(idx > -1) this.salidasProduccionSinQr.splice(idx, 1);
    },
    saveSalidaProduccionSinQr(confirm = false){
      const idsTrabajoOrdenDetalle = (this.movimientoItem.idsTrabajoOrdenDetalle || [])
        .map(id => parseInt(id, 10))
        .filter(id => Number.isInteger(id) && id > 0);

      const payload = {
        idTrabajoOrden: this.movimientoItem.idTrabajoOrden,
        idsTrabajoOrdenDetalle: idsTrabajoOrdenDetalle,
        idMaquina: this.movimientoItem.idMaquina,
        idOperador: (this.movimientoItem.idOperador > 0) ? this.movimientoItem.idOperador : null,
        confirmacion: confirm,
        salidas: this.salidasProduccionSinQr.map(s => ({
          idArticulo: s.idArticulo,
          idAlmacen: s.idAlmacen,
          cantidad: parseFloat(s.cantidad)
        }))
      };

      axios
        .post('/Inventario/SalidaProduccionSinQR', payload)
        .then(() => {
          this.saving = false;
          this.dialogAlertaMP = false;
          this.close(1);
        })
        .catch(error => {
          this.saving = false;
          if(error && error.response && error.response.status == 409){
            this.dialogAlertaMP = true;
            this.lottieKey++;
            return;
          }
          const mensaje = (error && error.response && error.response.data && error.response.data.msg)
            ? error.response.data.msg
            : 'No se pudo registrar la salida a producción';
          this.errores = [mensaje];
          this.error = true;
          console.log(error);
        });
    },
    limpiarArticulosTabla(){
      this.movimientoItem.salidas = [];
      this.erroresCantidades = [];
      if(this.movimientoItem.idPublicoVenta == null){
        this.errorOrdenVenta = "Debe seleccionar una Orden de Venta";
      }
    },
    validarCantidadDesglose(item = null){
      const desgloseIndex = (typeof item == 'number') ? item : this.movimientoItem.reintegros.indexOf(item);
      if(desgloseIndex == -1) return; //No se encontro el desglose
      if(this.expanded.indexOf(this.movimientoItem.reintegros[desgloseIndex]) == -1) return; //el reintegro no se ha desglosado 
      this.movimientoItem.reintegros[desgloseIndex].msgDesgloses = [];
      if(this.movimientoItem.reintegros[desgloseIndex].cantidad <= 0) {
        this.movimientoItem.reintegros[desgloseIndex].msgDesgloses.push(`Reintegro #${desgloseIndex+1}: Debe ingresar una cantidad valida`);
        return;
      }
      const sumValida = this.validarSumatoria(desgloseIndex);
      this.movimientoItem.reintegros[desgloseIndex].trabajoOrdenes.ordenesTrabajoDetalle.forEach( odt => {
        odt.valido = sumValida;
      });
    },
    validarSumatoria(desgloseIndex){
      let sumatoria = 0;
      try {
        this.movimientoItem.reintegros[desgloseIndex].trabajoOrdenes.ordenesTrabajoDetalle.forEach( (odt,idx) => {
          if(isNaN(parseFloat(odt.cantidad)) || parseFloat(odt.cantidad) < 0){
            odt.valido = false;
            this.movimientoItem.reintegros[desgloseIndex].msgDesgloses.push(`Reintegro #${desgloseIndex+1}: Ingrese una cantidad valida en el Desglose #${idx+1}`);
            throw 'BreakException';
          }
          else sumatoria += parseFloat(odt.cantidad);
        });
      } catch (error) {
        return false;
      }
      if((sumatoria+parseFloat(this.movimientoItem.reintegros[desgloseIndex].cantidad)) > this.movimientoItem.reintegros[desgloseIndex].maximo){
        this.movimientoItem.reintegros[desgloseIndex].msgDesgloses.push(`Reintegro #${desgloseIndex+1}: La sumatoria de las cantidades de los desgloses y la cantidad de reintegro no debe ser mayor a la cantidad maxima de ${this.movimientoItem.reintegros[desgloseIndex].maximo} ${this.$utils.strings.pluralizar(this.movimientoItem.reintegros[desgloseIndex].unidad,this.movimientoItem.reintegros[desgloseIndex].maximo,false)}`);
        return false;
      }
      if((sumatoria+parseFloat(this.movimientoItem.reintegros[desgloseIndex].cantidad)) < this.movimientoItem.reintegros[desgloseIndex].maximo){
        this.movimientoItem.reintegros[desgloseIndex].msgDesgloses.push(`Reintegro #${desgloseIndex+1}: La sumatoria de las cantidades de los desgloses y la cantidad de reintegro debe ser igual a la cantidad de ${this.movimientoItem.reintegros[desgloseIndex].maximo} ${this.$utils.strings.pluralizar(this.movimientoItem.reintegros[desgloseIndex].unidad,this.movimientoItem.reintegros[desgloseIndex].maximo,false)}`);
        return false;
      }
      return true;
    },
    handleExpansion(item, state){
      const itemIndex = this.expanded.indexOf(item);
      state ? this.expanded.splice(itemIndex, 1) : this.expanded.push(item);
    },
    desglosarReintegro(item, state){
      this.handleExpansion(item,state);
      if(!state){
        item.trabajoOrdenes.ordenesTrabajoDetalle.forEach( odt => {
          odt.cantidad = 0;
        });
        this.validarCantidadDesglose(item);
      }
      else{
        item.trabajoOrdenes.ordenesTrabajoDetalle.forEach( odt => {
          odt.cantidad = 0;
          odt.valido = null;
        });
        item.msgDesgloses = [];
      }
    },
    cerrarDialogAlertaMovimientoReciente(){
      this.dialogAlertaMovimientoReciente = false;
      this.movimientoRecienteItem = Object.assign({},this.defaultMovimientoRecienteItem);
    },
    cerrarDialogAlertaMP(){
      this.dialogAlertaMP = false;
    },
    getArticuloTipo(){
      this.movimientoItem.idTrabajoOrden = -1;
      this.movimientoItem.idTrabajoOrdenDetalle = -1;
      this.movimientoItem.idsTrabajoOrdenDetalle = [];
      const search =  this.articulos.find(articulo => articulo.idArticulo == this.movimientoItem.idArticulo);
      this.movimientoItem.idArticuloTipo = search != undefined ? search.idArticuloTipo : -1;
    },
    nombre(item){
      return  "["+item.codigo+"] - "+item.nombre;
    },
    proveedorLabel(item){
      return "["+item.codigo+"] - "+ item.nombre;
    },
    proveedorTipoLabel(item){
      return "["+item.codigo+"] - "+ item.nombre;
    },
    operadorLabel(item){
      return item.nombre +" "+ item.paterno +" "+ item.materno;
    },
    maquinaLabel(item){
      return "["+item.nombre +"] - "+item.marca + " " + item.modelo; 
    },
    onClearOperador(){
      this.movimientoItem.idOperador = -1;
    },
    initialize(){
      this.soundBeep = new Howl({
        src: ['/sounds/beep.webm','/sounds/beep.mp3']
      });
      this.soundError = new Howl({
        src: ['/sounds/error.webm','/sounds/error.mp3']
      });
      this.getArticuloTipos();
      this.getArticulos();
      this.getArticulosSinQr();
      this.getMovimientosEntradasGenerales();
      this.getOTs();
      this.getProveedores();
      this.getProveedorTipos();
      this.getAlmacenes();
      this.getSubalmacenes();
      this.getOperadores();
      this.getMaquinas();
      this.getCalidadTipos();
      this.getClientes();
      this.getOrdenesVentaPublico();
      this.getLecturasRemotas();
      this.totality = 0;
      this.movimientoDesglose;
      this.movimientoDesglose.payload;
			this.porcentajes = [];
			this.cantidades = [];
			this.errores = [];
			this.porcentajesValidos = false;
			this.cantidadesValidos = false;
			this.getSinDesglosar();
    },
    getOrdenesVentaPublico(){
      this.loadPublicoVenta = true;
      axios
        .get('/Inventario/OrdenVentaPublico')
        .then( response => {
          this.ordenesVentaPublico = response.data.filter(venta => venta.clave != '');
          this.loadPublicoVenta = false;
          //console.log("hola");
        })
        .catch( error => {
          console.log(error);
          this.loadPublicoVenta = false;
        })
    },
    getClientes(){
      axios
      .get("/Clientes")
      .then(response => {
        this.clientes = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getProveedores(){
      axios
      .get("/Proveedores")
      .then(response => {
        this.listaProveedores = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getProveedorTipos(){
      axios
      .get("/ProveedorTipos")
      .then(response => {
        this.proveedorTipos = response.data;
      })
      .catch(error => {
        console.log(error);
      })
    },
    resetOT(){
      this.movimientoItem.idTrabajoOrden = -1;
      this.movimientoItem.idTrabajoOrdenDetalle = -1;
      this.movimientoItem.idsTrabajoOrdenDetalle = [];
    },
    async getArticuloTipos(){
      try {
        const response = await axios.get('/Articulos/ArticuloTipos');
        this.articulosTipos = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    getArticulos(){
      this.loadingArticulos = true;
      axios
        .get("/Articulos/ArticulosNombres")
        .then(response => {
          this.articulosCatalogoRaw = response.data || [];
          const articulos = [];
          this.articulosTipos
              .sort( (a,b) => a.idArticuloTipo - b.idArticuloTipo )
              .forEach( (artip,idx) => {
                if(idx > 0) articulos.push({divider: true});
                articulos.push({ header: artip.nombre });
                const articfiltrados = (response.data || [])
                  .filter( articulo => articulo.idArticuloTipo == artip.idArticuloTipo )
                  .map( articulo => ({
                    ...articulo,
                    group: artip.nombre
                  }));
                articulos.push( ...articfiltrados );
              });
          this.articulos = articulos;
          this.loadingArticulos = false;
        })
        .catch(error => {
          this.loadingArticulos = false;
          console.log(error);
        })
    },
    getArticulosSinQr(){
      axios
        .get("Articulos/ArticulosSinQr")
        .then(response => {
          this.articulosSinQr = response.data || [];
        })
        .catch(error => {
          this.articulosSinQr = [];
          console.log(error);
        });
    },
    getMovimientosEntradasGenerales(){
      axios
        .get("/Inventario/Movimientos?TipoMovimiento=2")
        .then(response => {
          this.movimientosEntradasGenerales = response.data || [];
        })
        .catch(error => {
          this.movimientosEntradasGenerales = [];
          console.log(error);
        });
    },
    async getMovimientosEntradasAlmacen(idAlmacen){
      if(idAlmacen == null){
        this.movimientosEntradasAlmacen = [];
        this.loadingMovimientosUbicacion = false;
        this.saldosArticulosUbicacionApi = {};
        this.loadingSaldosArticulosUbicacion = false;
        return;
      }
      this.loadingMovimientosUbicacion = true;
      try{
        const response = await axios.get(`/Inventario/Movimientos?idAlmacen=${idAlmacen}`);
        this.movimientosEntradasAlmacen = response.data || [];
      }catch(error){
        this.movimientosEntradasAlmacen = [];
        console.log(error);
      }finally{
        this.loadingMovimientosUbicacion = false;
      }
      await this.cargarSaldosArticulosUbicacion(idAlmacen);
    },
    getOTs(){
      axios
        .get("TrabajoOrdenes/ListarOT?otsCerradas=true")
        .then(response => {
          this.trabajoOrdenes = response.data;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getSubalmacenes() {
			axios
				.get("/Subalmacenes")
				.then((response) => {
					this.subalmacenes = response.data;
				})
				.catch(console.log);
		},
    getAlmacenes(){
      axios
      .get("/Almacenes")
      .then(response => {
        response.data.forEach(e => {
          if(e.idCliente == null){
            e.cliente = this.nombreEmpresa;
          }
        });
        this.almacenes = response.data;
      })
      .catch(error => {
        console.log(error);
      })
    },
    getCalidadTipos(){
      axios
      .get("/CalidadTipos")
      .then(response => {
        this.calidadTipos=response.data;
      })
      .catch(error => {
        console.log(error);
      })
    },
    getMaquinas(){
      axios
      .get("/MaquinaInstancias")
      .then(response =>  {
        this.maquinas = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    },
    getOperadores(){
      axios
      .get("/Personas/Operadores")
      .then(response =>  {
        this.operadores = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    },
    almacenText(item){
      return "["+item.nombre+"] - "+item.cliente; 
    },
    calidadTipoText(item){
      return item.nombre; 
    },
    setDetalles(idTrabajoOrden){
      var pos = this.trabajoOrdenes.findIndex(element => element.idTrabajoOrden == idTrabajoOrden);
      if(pos >= 0){
        var trabajoOrden = this.trabajoOrdenes[pos];
        this.trabajoOrdenDetalles = trabajoOrden.detalles;
        var idsAlmancenes = this.almacenes.filter(a => a.idCliente == null).map(a => a.idAlmacen);
        
        if(trabajoOrden.maquila){
          idsAlmancenes.push(trabajoOrden.idAlmacen);
        }

        var nElementosRemover = this.movimientoItem.salidas.filter(a => {
          return idsAlmancenes.indexOf(a.idAlmacen) == -1;
        }).length;

        if(nElementosRemover > 0){
          this.movimientoItem.salidas = this.movimientoItem.salidas.filter(a => {
            return idsAlmancenes.indexOf(a.idAlmacen) >= 0;
          });
          this.soundError.play();
          this.$notify({
            group: 'inventario',
            title: 'Se ha'+(nElementosRemover > 1?'n':'')+' removido '+nElementosRemover+' elemento'+(nElementosRemover > 1?'s':'')+' que no se pueden usar para esta ODT',
            type: 'error',
          });
        }
      }
      else this.trabajoOrdenDetalles = [];
    },
    setUnidad(idArticulo){
      var pos = this.articulos.findIndex(a => a.idArticulo == idArticulo);
      if(pos >= 0){
        this.unidad = this.articulos[pos].unidad;
      }
      else{
        this.unidad = "";
      }
    },
    onChangeAlmacenDestinoSalida(){
      this.articuloSalidaAlmacenKey = null;
      this.movimientoItem.idSubalmacenDestino = null;
      if(!(this.movimientoItem.idAlmacenDestino > 0)) return;

      this.getMovimientosEntradasGenerales();
      const totalAnterior = this.movimientoItem.salidas.length;
      this.movimientoItem.salidas = this.movimientoItem.salidas.filter(item => {
        const idAlmacenOrigen = this.obtenerIdAlmacenMovimiento(item);
        return idAlmacenOrigen == null || idAlmacenOrigen != this.movimientoItem.idAlmacenDestino;
      });
      const removidos = totalAnterior - this.movimientoItem.salidas.length;
      const destinoTexto = this.almacenDestinoSalidaTexto;
      const subDestinoTexto = this.subalmacenDestinoSalidaTexto;
      this.movimientoItem.salidas = this.movimientoItem.salidas.map(item => ({
        ...item,
        almacenDestino: destinoTexto,
        idSubalmacenDestino: this.movimientoItem.idSubalmacenDestino,
        subalmacenDestino: subDestinoTexto
      }));
      if(removidos > 0){
        this.$notify({
          group: 'inventario',
          title: `Se removieron ${removidos} elemento(s) porque pertenecen al almacén destino`,
          type: 'warn',
        });
      }
    },
    onChangeSubalmacenDestinoSalida(){
      const subDestinoTexto = this.subalmacenDestinoSalidaTexto;
      this.movimientoItem.salidas = this.movimientoItem.salidas.map(item => ({
        ...item,
        idSubalmacenDestino: this.movimientoItem.idSubalmacenDestino,
        subalmacenDestino: subDestinoTexto
      }));
    },
    async agregarArticuloSalidaAlmacen(key = this.articuloSalidaAlmacenKey){
      if(!key) return;
      if(this.requiereSubalmacenDestinoSalida && this.movimientoItem.idSubalmacenDestino == null){
        this.soundError.play();
        this.$notify({
          group: 'inventario',
          title: 'Selecciona un subalmacén destino antes de agregar artículos',
          type: 'error',
        });
        return;
      }
      const seleccionado = this.articulosDisponiblesSalidaAlmacen.find(item => item.key == key);
      this.articuloSalidaAlmacenKey = null;
      if(!seleccionado) return;

      const repetido = this.movimientoItem.salidas.find(item =>
        this.obtenerIdAlmacenMovimiento(item) == seleccionado.idAlmacen &&
        this.obtenerIdSubalmacenMovimiento(item) == seleccionado.idSubalmacen &&
        this.obtenerIdArticuloMovimiento(item) == seleccionado.idArticulo
      );
      if(repetido){
        this.soundError.play();
        this.$notify({
          group: 'inventario',
          title: 'Ese artículo ya fue agregado en la lista de salidas',
          type: 'error',
        });
        return;
      }

      try{
        let url = `/Inventario/InformacionBasicaSinQR?IdArticulo=${seleccionado.idArticulo}&IdAlmacen=${seleccionado.idAlmacen}`;
        if(seleccionado.idSubalmacen != null) url += `&IdSubalmacen=${seleccionado.idSubalmacen}`;

        const response = await axios.get(url);
        const info = response.data || {};
        const maximo = parseFloat(info.maximo || info.Maximo || 0);
        if(!(maximo > 0)){
          this.soundError.play();
          this.$notify({
            group: 'inventario',
            title: 'El artículo seleccionado no tiene existencia disponible para mover',
            type: 'error',
          });
          return;
        }

        this.movimientoItem.salidas.push({
          codigo: (seleccionado.codigo || "").toString().trim(),
          idAlmacen: seleccionado.idAlmacen,
          idSubalmacen: seleccionado.idSubalmacen == null ? null : seleccionado.idSubalmacen,
          idArticulo: seleccionado.idArticulo,
          articulo: seleccionado.articulo,
          almacen: seleccionado.almacen,
          subalmacen: seleccionado.subalmacen || "N/A",
          almacenDestino: this.almacenDestinoSalidaTexto,
          idSubalmacenDestino: this.movimientoItem.idSubalmacenDestino,
          subalmacenDestino: this.subalmacenDestinoSalidaTexto,
          proveedores: [],
          produccion: false,
          receta: false,
          maximo,
          cantidad: 0,
          abreviatura: info.abreviatura || info.Abreviatura || "",
          enUso: false
        });
        this.soundBeep.play();
      }
      catch(error){
        this.soundError.play();
        this.$notify({
          group: 'inventario',
          title: 'No se pudo agregar el artículo seleccionado',
          type: 'error',
        });
        console.log(error);
      }
    },
    onChangeAlmacenUbicacion(){
      this.erroresUbicacion = [];
      this.infoArticuloUbicacion = null;
      this.infoArticuloUbicacionApi = null;
      this.saldosArticulosUbicacionApi = {};
      this.sinSubalmacenDisponibleUbicacion = false;
      this.saldosSubalmacenUbicacion = {};
      this.movimientoUbicacionItem.idArticulo = null;
      this.movimientoUbicacionItem.idSubalmacenOrigen = null;
      this.movimientoUbicacionItem.idSubalmacenDestino = null;
      this.movimientoUbicacionItem.cantidad = undefined;
      this.movimientosEntradasAlmacen = [];
      this.getMovimientosEntradasAlmacen(this.movimientoUbicacionItem.idAlmacen);
    },
    onChangeArticuloUbicacion(){
      this.erroresUbicacion = [];
      this.infoArticuloUbicacion = null;
      this.infoArticuloUbicacionApi = null;
      this.movimientoUbicacionItem.idSubalmacenOrigen = null;
      this.movimientoUbicacionItem.idSubalmacenDestino = null;
      this.movimientoUbicacionItem.cantidad = undefined;
      this.sinSubalmacenDisponibleUbicacion = false;
      this.saldosSubalmacenUbicacion = {};
      this.cargarSaldosSubalmacenUbicacion();
    },
    onChangeSubalmacenOrigenUbicacion(){
      this.erroresUbicacion = [];
      this.infoArticuloUbicacion = null;
      this.infoArticuloUbicacionApi = null;
      this.movimientoUbicacionItem.idSubalmacenDestino = null;
      this.getInfoArticuloUbicacion();
    },
    getInfoArticuloUbicacion(){
      if (
        this.movimientoUbicacionItem.idAlmacen == null ||
        this.movimientoUbicacionItem.idArticulo == null ||
        this.movimientoUbicacionItem.idSubalmacenOrigen == null
      ) return;

      let url = `/Inventario/InformacionBasicaSinQR?IdArticulo=${this.movimientoUbicacionItem.idArticulo}&IdAlmacen=${this.movimientoUbicacionItem.idAlmacen}`;
      url += `&IdSubalmacen=${this.movimientoUbicacionItem.idSubalmacenOrigen}`;
      axios
        .get(url)
        .then(response => {
          const data = response.data || {};
          const cantidadApi = parseFloat(data.maximo || data.Maximo || 0);
          const cantidadFallback = Number(this.saldosSubalmacenUbicacion[String(this.movimientoUbicacionItem.idSubalmacenOrigen)] || 0);
          this.infoArticuloUbicacionApi = cantidadApi > 0
            ? { ...data, maximo: cantidadApi }
            : null;
          const cantidadFinal = Math.max(cantidadApi, cantidadFallback);
          this.infoArticuloUbicacion = cantidadFinal > 0
            ? { ...data, maximo: cantidadFinal }
            : null;
          this.movimientoUbicacionItem.cantidad = this.infoArticuloUbicacion ? this.infoArticuloUbicacion.maximo : undefined;
        })
        .catch(error => {
          this.infoArticuloUbicacionApi = null;
          const cantidadFallback = Number(this.saldosSubalmacenUbicacion[String(this.movimientoUbicacionItem.idSubalmacenOrigen)] || 0);
          this.infoArticuloUbicacion = cantidadFallback > 0
            ? { maximo: cantidadFallback }
            : null;
          this.movimientoUbicacionItem.cantidad = this.infoArticuloUbicacion ? this.infoArticuloUbicacion.maximo : undefined;
          console.log(error);
        });
    },
    async cargarSaldosSubalmacenUbicacion(){
      this.sinSubalmacenDisponibleUbicacion = false;
      this.saldosSubalmacenUbicacion = {};
      if (
        this.movimientoUbicacionItem.idAlmacen == null ||
        this.movimientoUbicacionItem.idArticulo == null
      ) return;

      const idAlmacen = this.movimientoUbicacionItem.idAlmacen;
      const idArticulo = this.movimientoUbicacionItem.idArticulo;
      const requestId = ++this.saldoSubalmacenRequestId;

      const idsSubalmacen = this.subalmacenes
        .filter(sub => sub.idAlmacen == idAlmacen)
        .map(sub => sub.idSubalmacen);
      idsSubalmacen.unshift(-1);

      const resultados = await Promise.all(
        idsSubalmacen.map(async idSubalmacen => {
          const url = `/Inventario/InformacionBasicaSinQR?IdArticulo=${idArticulo}&IdAlmacen=${idAlmacen}&IdSubalmacen=${idSubalmacen}`;
          try{
            const response = await axios.get(url);
            const data = response.data || {};
            const cantidad = parseFloat(data.maximo || data.Maximo || 0);
            return [idSubalmacen, Number.isFinite(cantidad) ? cantidad : 0];
          }catch(error){
            return [idSubalmacen, 0];
          }
        })
      );

      if(requestId != this.saldoSubalmacenRequestId) return;

      const mapaSaldos = {};
      resultados.forEach(([idSubalmacen, cantidad]) => {
        mapaSaldos[String(idSubalmacen)] = cantidad;
      });

      const mapaFallback = this.calcularSaldosSubalmacenDesdeMovimientos(idAlmacen, idArticulo);
      Object.keys(mapaFallback).forEach(key => {
        const saldoApi = Number(mapaSaldos[key] || 0);
        const saldoFallback = Number(mapaFallback[key] || 0);
        mapaSaldos[key] = Math.max(saldoApi, saldoFallback);
      });

      this.saldosSubalmacenUbicacion = mapaSaldos;
      this.sinSubalmacenDisponibleUbicacion = Number(mapaSaldos["-1"] || 0) > 0;

      const idSubalmacenPreferido = this.obtenerSubalmacenOrigenPreferidoUbicacion(idAlmacen, idArticulo, mapaSaldos);
      if (idSubalmacenPreferido != null) {
        this.movimientoUbicacionItem.idSubalmacenOrigen = idSubalmacenPreferido;
        this.getInfoArticuloUbicacion();
      }
    },
    agregarMovimientoUbicacion(){
      this.erroresUbicacion = [];
      if(this.movimientoUbicacionItem.idAlmacen == null) this.erroresUbicacion.push("Selecciona un almacén");
      if(this.movimientoUbicacionItem.idArticulo == null) this.erroresUbicacion.push("Selecciona un artículo");
      if(this.movimientoUbicacionItem.idSubalmacenOrigen == null) this.erroresUbicacion.push("Selecciona una ubicación actual");
      if(this.movimientoUbicacionItem.idSubalmacenDestino == null) this.erroresUbicacion.push("Selecciona una ubicación nueva");
      if(
        this.movimientoUbicacionItem.idSubalmacenOrigen != null &&
        this.movimientoUbicacionItem.idSubalmacenDestino != null &&
        this.movimientoUbicacionItem.idSubalmacenOrigen == this.movimientoUbicacionItem.idSubalmacenDestino
      ) {
        this.erroresUbicacion.push("La ubicación nueva no puede ser la misma que la ubicación actual");
      }
      const tieneSeleccionCompleta =
        this.movimientoUbicacionItem.idAlmacen != null &&
        this.movimientoUbicacionItem.idArticulo != null &&
        this.movimientoUbicacionItem.idSubalmacenOrigen != null;
      if(tieneSeleccionCompleta && this.infoArticuloUbicacion == null) {
        this.erroresUbicacion.push("No se encontró inventario para la combinación seleccionada");
      }

      const disponible = parseFloat((this.infoArticuloUbicacion && this.infoArticuloUbicacion.maximo) || 0);
      if(tieneSeleccionCompleta && this.infoArticuloUbicacion != null && disponible <= 0) {
        this.erroresUbicacion.push("No hay cantidad disponible para mover");
      }
      const cantidad = parseFloat(this.movimientoUbicacionItem.cantidad);
      if(tieneSeleccionCompleta && this.infoArticuloUbicacion != null && disponible > 0){
        if(isNaN(cantidad) || cantidad <= 0){
          this.erroresUbicacion.push("Captura una cantidad válida a mover");
        } else if(cantidad > disponible){
          this.erroresUbicacion.push("La cantidad a mover supera lo disponible (" + disponible + ")");
        }
      }

      const existe = this.movimientosUbicacion.find(item =>
        item.idAlmacen == this.movimientoUbicacionItem.idAlmacen &&
        item.idArticulo == this.movimientoUbicacionItem.idArticulo &&
        item.idSubalmacenOrigen == this.movimientoUbicacionItem.idSubalmacenOrigen &&
        item.idSubalmacenDestino == this.movimientoUbicacionItem.idSubalmacenDestino
      );
      if(existe) this.erroresUbicacion.push("Ya existe un movimiento con esos mismos datos");

      if(this.erroresUbicacion.length > 0) return;

      const almacen = this.almacenes.find(item => item.idAlmacen == this.movimientoUbicacionItem.idAlmacen);
      const articulo = this.articulosDisponiblesUbicacion.find(item => item.idArticulo == this.movimientoUbicacionItem.idArticulo);
      const subalmacenOrigen = this.subalmacenes.find(item => item.idSubalmacen == this.movimientoUbicacionItem.idSubalmacenOrigen);
      const subalmacenDestino = this.subalmacenes.find(item => item.idSubalmacen == this.movimientoUbicacionItem.idSubalmacenDestino);
      const abreviatura = (this.infoArticuloUbicacion && this.infoArticuloUbicacion.abreviatura) || "";

      this.movimientosUbicacion.push({
        idAlmacen: this.movimientoUbicacionItem.idAlmacen,
        idArticulo: this.movimientoUbicacionItem.idArticulo,
        idSubalmacenOrigen: this.movimientoUbicacionItem.idSubalmacenOrigen,
        idSubalmacenDestino: this.movimientoUbicacionItem.idSubalmacenDestino,
        almacen: almacen ? this.almacenText(almacen) : this.movimientoUbicacionItem.idAlmacen,
        articulo: articulo ? this.nombreArticulo(articulo) : this.movimientoUbicacionItem.idArticulo,
        subalmacenOrigen: this.movimientoUbicacionItem.idSubalmacenOrigen === -1
          ? "[SIN] - Sin subalmacén asignado"
          : (subalmacenOrigen ? this.nombreSubalmacen(subalmacenOrigen) : this.movimientoUbicacionItem.idSubalmacenOrigen),
        subalmacenDestino: subalmacenDestino ? this.nombreSubalmacen(subalmacenDestino) : this.movimientoUbicacionItem.idSubalmacenDestino,
        cantidad,
        cantidadLabel: `${cantidad} ${this.$utils.strings.pluralizar(abreviatura, cantidad, false)}`
      });

      this.infoArticuloUbicacion = null;
      this.infoArticuloUbicacionApi = null;
      this.movimientoUbicacionItem.idArticulo = null;
      this.movimientoUbicacionItem.idSubalmacenOrigen = null;
      this.movimientoUbicacionItem.idSubalmacenDestino = null;
      this.movimientoUbicacionItem.cantidad = undefined;
    },
    eliminarMovimientoUbicacion(item){
      const index = this.movimientosUbicacion.indexOf(item);
      if(index > -1) this.movimientosUbicacion.splice(index, 1);
    },
    onToggleModoUbicacionQR(){
      // Al cambiar de modo se limpia el estado de ambos para evitar mezclas.
      this.erroresUbicacion = [];
      this.ubicacionQRCodigo = "";
      this.movimientosUbicacionQR = [];
      this.movimientoUbicacionItem.idArticulo = null;
      this.movimientoUbicacionItem.idSubalmacenOrigen = null;
      this.movimientoUbicacionItem.idSubalmacenDestino = null;
      this.movimientoUbicacionItem.cantidad = undefined;
      this.infoArticuloUbicacion = null;
      this.movimientosUbicacion = [];
    },
    setCodeStyleUbicacionQR(){
      if(this.ubicacionQRCodigo.length >= 1){
        try{
          if(this.ubicacionQRCodigo[0] == '@' && this.ubicacionQRCodigo.length > 1){
            this.ubicacionQRCodigo = "@" + this.ubicacionQRCodigo.substring(1).toUpperCase().replace(/-/g, '').match(/.{1,3}/g).join('-');
          }
          else this.ubicacionQRCodigo = this.ubicacionQRCodigo.toUpperCase().replace(/-/g, '').match(/.{1,3}/g).join('-');
        }
        catch{ this.ubicacionQRCodigo = ''; }
      }
    },
    getCodeUbicacionQR(){
      var codigo = this.ubicacionQRCodigo.toUpperCase().replace(/-/g, '');
      if(codigo.length == 10 && codigo[0] == "@"){ this.onDecodeUbicacionQR(codigo); this.ubicacionQRCodigo = ""; }
      if(codigo.length == 9 && this.onlyNumberAndLetters(codigo)){ this.onDecodeUbicacionQR(codigo); this.ubicacionQRCodigo = ""; }
    },
    onDecodeUbicacionQR(code){
      if(this.movimientosUbicacionQR.find(x => x.codigo == code)){
        this.soundError.play();
        this.$notify({ group: 'inventario', title: 'Ya se agregó la tarima con el Código '+code.match(/.{1,3}/g).join('-'), type: 'error' });
        return;
      }
      axios
      .get("/Inventario/InformacionBasica?Codigo="+code+"&tipoMovimiento=6")
      .then(response => {
        const data = response.data;
        if(data.enUso){
          this.soundError.play();
          this.$notify({ group: 'inventario', title: 'La tarima '+code.match(/.{1,3}/g).join('-')+' está en uso en una ODT', type: 'error' });
          return;
        }
        const maximo = parseFloat(data.maximo);
        if(isNaN(maximo) || maximo <= 0){
          this.soundError.play();
          this.$notify({ group: 'inventario', title: 'La tarima no tiene existencia disponible', type: 'error' });
          return;
        }
        this.movimientosUbicacionQR.push({
          idElemento: data.idElemento,
          codigo: data.codigo,
          articulo: data.articulo,
          idAlmacen: data.idAlmacen,
          almacen: data.almacen,
          idSubalmacenOrigen: (data.idsubalmacen != null ? data.idsubalmacen : (data.idSubalmacen != null ? data.idSubalmacen : null)),
          subalmacen: data.subalmacen,
          maximo: maximo,
          abreviatura: data.abreviatura,
          idSubalmacenDestino: null,
          cantidad: maximo
          // Folio nuevo en movimiento entre ubicaciones DESACTIVADO a solicitud:
          // folioNuevo: null
        });
        this.soundBeep.play();
      })
      .catch(() => {
        this.soundError.play();
        this.$notify({ group: 'inventario', title: 'No existe una tarima con el Código '+code.match(/.{1,3}/g).join('-'), type: 'error' });
      });
    },
    subalmacenesDestinoUbicacionQR(item){
      return this.subalmacenes
        .filter(sub => sub.idAlmacen == item.idAlmacen)
        .filter(sub => sub.idSubalmacen != item.idSubalmacenOrigen);
    },
    eliminarUbicacionQR(item){
      const i = this.movimientosUbicacionQR.indexOf(item);
      if(i > -1) this.movimientosUbicacionQR.splice(i, 1);
    },
    saveMovimientoUbicacionQR(){
      this.erroresUbicacion = [];
      if(this.movimientosUbicacionQR.length == 0){
        this.saving = false;
        this.erroresUbicacion.push("Pistolea al menos una tarima");
        return;
      }
      this.movimientosUbicacionQR.forEach((item, idx) => {
        if(item.idSubalmacenDestino == null){
          this.erroresUbicacion.push("Renglón "+(idx+1)+": selecciona la ubicación nueva");
        }
        else if(item.idSubalmacenDestino == item.idSubalmacenOrigen){
          this.erroresUbicacion.push("Renglón "+(idx+1)+": la ubicación nueva debe ser distinta a la actual");
        }
        const cantidad = parseFloat(item.cantidad);
        if(isNaN(cantidad) || cantidad <= 0){
          this.erroresUbicacion.push("Renglón "+(idx+1)+": cantidad inválida");
        }
        else if(cantidad > item.maximo){
          this.erroresUbicacion.push("Renglón "+(idx+1)+": la cantidad supera lo disponible ("+item.maximo+")");
        }
      });
      if(this.erroresUbicacion.length > 0){ this.saving = false; return; }

      const payload = this.movimientosUbicacionQR.map(item => ({
        IdAlmacen: item.idAlmacen,
        IdSubalmacen: item.idSubalmacenDestino,
        IdElemento: item.idElemento,
        Cantidad: parseFloat(item.cantidad)
        // Folio nuevo en movimiento entre ubicaciones DESACTIVADO a solicitud (arrastra folio original):
        // FolioNuevo: (parseFloat(item.cantidad) < item.maximo && item.folioNuevo && item.folioNuevo.toString().trim())
        //   ? item.folioNuevo.toString().trim()
        //   : null
      }));

      axios
        .post("/Inventario/CrearMovimientoMontacargas", payload)
        .then(response => {
          this.saving = false;
          if(response.data != null && response.data.length > 0){
            this.qrPdf = response.data;
            this.state = 1;
            return;
          }
          this.close(1);
        })
        .catch(error => {
          this.saving = false;
          const mensaje = (error && error.response && error.response.data && error.response.data.msg)
            ? error.response.data.msg
            : "No se pudo reubicar la tarima";
          this.erroresUbicacion = [mensaje];
          console.log(error);
        });
    },
    async saveMovimientoUbicacion(){
      if(this.modoUbicacionQR){
        this.saveMovimientoUbicacionQR();
        return;
      }
      if(this.movimientosUbicacion.length < 1){
        this.saving = false;
        this.errores = ["Debes agregar al menos un movimiento entre ubicaciones"];
        this.error = true;
        return;
      }

      const payload = this.movimientosUbicacion.map(item => ({
        idAlmacenOrigen: item.idAlmacen,
        idSubalmacenOrigen: item.idSubalmacenOrigen === -1 ? null : item.idSubalmacenOrigen,
        idAlmacenDestino: item.idAlmacen,
        idSubalmacenDestino: item.idSubalmacenDestino,
        idArticulo: item.idArticulo,
        cantidad: item.cantidad
      }));

      const url = "/Inventario/CrearMovimientoEntreAlmacenesSinQRAjustado";
      axios
        .post(url, payload)
        .then((response) => {
          this.saving = false;
          if(response.data != null && response.data.length > 0){
            this.qrPdf = response.data;
            this.state = 1;
            return;
          }
          this.close(1);
        })
        .catch(error => {
          this.saving = false;
          const mensaje = (error && error.response && error.response.data && error.response.data.msg)
            ? error.response.data.msg
            : "No se pudo guardar el movimiento entre ubicaciones";
          this.errores = [mensaje];
          this.error = true;
          console.log(error);
        });
    },
    saveSalidaAAlmacen(){
      const payloadMap = new Map();

      this.movimientoItem.salidas.forEach((salida) => {
        const idAlmacenOrigen = this.obtenerIdAlmacenMovimiento(salida);
        const idSubalmacenOrigen = this.obtenerIdSubalmacenMovimiento(salida);
        const idSubalmacenDestino = (salida.idSubalmacenDestino != null)
          ? salida.idSubalmacenDestino
          : this.movimientoItem.idSubalmacenDestino;
        const idArticulo = this.obtenerIdArticuloMovimiento(salida);
        const cantidad = this.movimientoItem.idTipoMovimiento == 1 ? parseFloat(salida.maximo) : parseFloat(salida.cantidad);
        if(idAlmacenOrigen == null || idArticulo == null || isNaN(cantidad) || cantidad <= 0) return;

        const key = `${idAlmacenOrigen}|${idSubalmacenOrigen == null ? "null" : idSubalmacenOrigen}|${idArticulo}|${idSubalmacenDestino == null ? "null" : idSubalmacenDestino}`;
        if(!payloadMap.has(key)){
          payloadMap.set(key, {
            idAlmacenOrigen,
            idSubalmacenOrigen: idSubalmacenOrigen == null ? null : idSubalmacenOrigen,
            idAlmacenDestino: this.movimientoItem.idAlmacenDestino,
            idSubalmacenDestino: idSubalmacenDestino == null ? null : idSubalmacenDestino,
            idArticulo,
            cantidad: 0
          });
        }
        payloadMap.get(key).cantidad += cantidad;
      });

      const payload = Array.from(payloadMap.values());
      if(payload.length == 0){
        this.saving = false;
        this.errores = ["No se pudo construir el traspaso a almacén con los elementos seleccionados"];
        this.error = true;
        return;
      }

      const url = "/Inventario/CrearMovimientoEntreAlmacenesSinQRAjustado";
      axios
        .post(url, payload)
        .then((response) => {
          this.saving = false;
          if(response.data != null && response.data.length > 0){
            this.qrPdf = response.data;
            this.state = 1;
            return;
          }
          this.close(1);
        })
        .catch(error => {
          this.saving = false;
          const mensaje = (error && error.response && error.response.data && error.response.data.msg)
            ? error.response.data.msg
            : "No se pudo guardar el movimiento entre almacenes";
          this.errores = [mensaje];
          this.error = true;
          console.log(error);
        });
    },
    reset(){
      this.state = 0;
      this.codigo = '';
      this.movimientoItem = Object.assign({},this.defaultItem);
      this.movimientoItem.elementos = [];
      this.movimientoItem.proveedores = [];
      this.movimientoItem.salidas = [];
      this.movimientoItem.reintegros = [];
      this.movimientoItem.desgloses = [];  //añadido pal desglose
      this.unidad = "";
      this.errorOrdenVenta = "";
      this.erroresCantidades = [];
      this.editarCantidadSalida = false;
      this.expanded = [];
      this.desgloses = [];
      this.movimientosUbicacion = [];
      this.modoUbicacionQR = false;
      this.ubicacionQRCodigo = "";
      this.movimientosUbicacionQR = [];
      this.movimientosEntradasAlmacen = [];
      this.movimientosEntradasGenerales = [];
      this.loadingMovimientosUbicacion = false;
      this.loadingSaldosArticulosUbicacion = false;
      this.erroresUbicacion = [];
      this.infoArticuloUbicacion = null;
      this.infoArticuloUbicacionApi = null;
      this.saldosArticulosUbicacionApi = {};
      this.sinSubalmacenDisponibleUbicacion = false;
      this.saldosSubalmacenUbicacion = {};
      this.saldoArticuloRequestId = 0;
      this.saldoSubalmacenRequestId = 0;
      this.articuloSalidaAlmacenKey = null;
      this.produccionDisponible = null;
      this.loadingProduccion = false;
      this.cantidadIngreso = 0;
      this.sinQrProduccion = false;
      this.sinQrItem = { idAlmacen: -1, idArticulo: -1, cantidad: undefined, maximo: null };
      this.salidasProduccionSinQr = [];
      this.loadingSinQrStock = false;
      this.movimientoUbicacionItem = {
        idAlmacen: null,
        idArticulo: null,
        idSubalmacenOrigen: null,
        idSubalmacenDestino: null
      };
      this.showWizard = false;
    },
    close(status = 0){
      this.reset();
      this.showWizard = false;
      this.show = false;
      this.$emit('change',status);
    },
    parseToFloat(string){
      if(isNaN(parseFloat(string))) return 0.0;
      else return parseFloat(string);
    },
    validate(){
      this.errorOrdenVenta = "";
      this.erroresCantidades = []
      this.errores = [];
      if(this.movimientoItem.idTipoMovimiento <= 0){
        this.errores.push("Debe de seleccionar un Tipo de Movimiento");
      }
      else{
        if((this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6)){
          if(this.movimientoItem.tipoSalida > 0){
            if(this.movimientoItem.tipoSalida == 1){
              if(this.movimientoItem.idTrabajoOrden <= 0){
                this.errores.push("Debe de Seleccionar una Orden de Trabajo");
              }
              if(this.movimientoItem.idsTrabajoOrdenDetalle.length == 0){
                this.errores.push("Debe de Seleccionar al menos un Artículo a Producir");
              }
              if(this.movimientoItem.idMaquina <= 0){
                this.errores.push("Debe de Seleccionar una Máquina a Producir");
              }
              if(this.esProduccionSinQr){
                if(this.salidasProduccionSinQr.length == 0){
                  this.errores.push("Debe agregar al menos una materia prima");
                }
                else{
                  this.salidasProduccionSinQr.forEach((salida,idx) => {
                    if(isNaN(parseFloat(salida.cantidad)) || parseFloat(salida.cantidad) <= 0){
                      this.errores.push("La cantidad de la materia prima en el renglón "+(idx+1)+" no es válida");
                    }
                  })
                }
              }
              else if(this.movimientoItem.salidas.length == 0){
                this.errores.push("Debe Ingresar al menos un Elemento");
              }
              else{
                const usaCantidad = this.editarCantidadSalida || this.movimientoItem.idTipoMovimiento == 6;
                this.movimientoItem.salidas.forEach((salida,idx) => {
                  const cantidad = usaCantidad ? parseFloat(salida.cantidad) : parseFloat(salida.maximo);
                  if(isNaN(cantidad) || cantidad <= 0){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" no es válida");
                  }
                  if(usaCantidad && cantidad > parseFloat(salida.maximo)){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" es mayor de lo permitido");
                  }
                })
              }
            }

            else if(this.movimientoItem.tipoSalida == 2){
              if(this.movimientoItem.idCliente <= 0){
                this.errores.push("Debe de Seleccionar un Cliente");
              }
              if(this.movimientoItem.salidas.length == 0){
                this.errores.push("Debe Ingresar al menos un Elemento");
              }
              else{
                this.movimientoItem.salidas.forEach((salida,idx) => {
                  const cantidad = parseFloat(salida.cantidad);
                  if(isNaN(cantidad) || cantidad <= 0){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" no es válida");
                  }
                  else if(cantidad > parseFloat(salida.maximo)){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" es mayor de lo permitido");
                  }
                })

              }
            }
            else if(this.movimientoItem.tipoSalida == 4){
              if(this.movimientoItem.salidas.length == 0){
                this.errores.push("Debe Ingresar al menos un Elemento");
              }
              else{
                this.movimientoItem.salidas.forEach((salida,idx) => {
                  const cantidad = parseFloat(salida.cantidad);
                  if(isNaN(cantidad) || cantidad <= 0){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" no es válida");
                  }
                  else if(cantidad > parseFloat(salida.maximo)){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" es mayor de lo permitido");
                  }
                })
              }
            }
            else if(this.movimientoItem.tipoSalida == 3){
              if(this.movimientoItem.idOperador <= 0){
                this.errores.push("Debe de Seleccionar Quien Recibió");
              }
              if(this.movimientoItem.salidas.length == 0){
                this.errores.push("Debe Ingresar al menos un Elemento");
              }
              else{
                this.movimientoItem.salidas.forEach((salida,idx) => {
                  if(salida.cantidad > salida.maximo){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" es mayor de lo permitido");
                  }
                })
              }
            }
            else if(this.movimientoItem.tipoSalida == 6){
              if(this.movimientoItem.idAlmacenDestino <= 0){
                this.errores.push("Debe de Seleccionar un Almacén destino");
              }
              if(this.requiereSubalmacenDestinoSalida && this.movimientoItem.idSubalmacenDestino == null){
                this.errores.push("Debe de seleccionar un Subalmacén destino");
              }
              if(this.movimientoItem.salidas.length == 0){
                this.errores.push("Debe Ingresar al menos un Elemento");
              }
              else{
                this.movimientoItem.salidas.forEach((salida,idx) => {
                  const idAlmacenOrigen = this.obtenerIdAlmacenMovimiento(salida);
                  const cantidad = this.movimientoItem.idTipoMovimiento == 1 ? parseFloat(salida.maximo) : parseFloat(salida.cantidad);
                  if(this.movimientoItem.idTipoMovimiento == 6){
                    if(isNaN(cantidad) || cantidad <= 0){
                      this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" no es válida");
                    }
                    if(cantidad > parseFloat(salida.maximo)){
                      this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" es mayor de lo permitido");
                    }
                  }
                  if(idAlmacenOrigen != null && idAlmacenOrigen == this.movimientoItem.idAlmacenDestino){
                    this.errores.push("El almacén destino debe ser distinto al almacén origen en el renglón "+(idx+1));
                  }
                });
              }
            }
            else if(this.movimientoItem.tipoSalida == 7){
              if(this.movimientoItem.idTrabajoOrden <= 0){
                this.errores.push("Debe de Seleccionar una Orden de Trabajo");
              }
              if(this.movimientoItem.idTrabajoOrdenDetalle <= 0){
                this.errores.push("Debe de Seleccionar un Artículo a Producir");
              }
              if(this.movimientoItem.idAlmacenDestino <= 0){
                this.errores.push("Debe de Seleccionar un Almacén destino");
              }
              if(this.subalmacenesDestinoSalida.length > 0 && this.movimientoItem.idSubalmacenDestino == null){
                this.errores.push("Debe de seleccionar un Subalmacén destino");
              }
              const cantidadIngresar = parseFloat(this.cantidadIngreso);
              const disponibleEnviar = this.produccionDisponible ? parseFloat(this.produccionDisponible.diferencia) : 0;
              if(isNaN(cantidadIngresar) || cantidadIngresar <= 0){
                this.errores.push("Debe ingresar una cantidad válida");
              }
              else if(cantidadIngresar > disponibleEnviar){
                this.errores.push("La cantidad supera lo disponible por enviar a almacén");
              }
            }
            else if( this.movimientoItem.tipoSalida == 5 ){
              if(this.movimientoItem.idPublicoVenta == null){
                this.errorOrdenVenta = "Debe seleccionar una Orden de Venta";
                this.errores.push(this.errorOrdenVenta);
              }

              if(this.movimientoItem.salidas.length == 0){
                this.errores.push("Debe Ingresar al menos un Elemento");
              }
              else{
                const articulosSalidasUnique = [];
                const uniqueArticulosSet = [...new Set(this.movimientoItem.salidas.map(salida => salida.idArticulo))]
                uniqueArticulosSet.forEach( salida => {
                  this.articulosOrdenVenta.forEach( articulo => {
                    if(articulo.idArticulo == salida){
                      articulosSalidasUnique.push({
                        idArticulo: salida,
                        cantidad: 0,
                        articulo: this.nombreArticulo(articulo)
                      });
                    }
                  });
                });
                
                // if(articulosSalidasUnique.length != this.articulosOrdenVenta.length){
                //   this.errores.push("Faltan Elementos para surtir la Orden de Venta");
                // }
                this.movimientoItem.salidas.forEach((salida,idx) => {
                  if(salida.cantidad > salida.maximo){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" es mayor de lo permitido");
                  }
                  if(salida.cantidad <= 0){
                    this.errores.push("La cantidad del Elemento en el renglón "+(idx+1)+" es menor de lo permitido");
                  }

                  //Llenado de sumatorias
                  articulosSalidasUnique.forEach( articulo => {
                    if(salida.idArticulo == articulo.idArticulo){
                      articulo.cantidadRequerida = salida.cantidadRequerida;
                      articulo.abreviatura = salida.abreviatura;
                      articulo.cantidad += salida.cantidad;
                    }
                  })
                });

                //Validan sumatorias
                articulosSalidasUnique.forEach( articulo => {
                  if(articulo.cantidad > articulo.cantidadRequerida ){
                    this.erroresCantidades.push(articulo.idArticulo);
                    this.errores.push(`La sumatoria de cantidades del artículo "${articulo.articulo}" es mayor a la Cantidad Requerida de ${articulo.cantidadRequerida} ${this.$utils.strings.pluralizar(articulo.abreviatura,articulo.cantidadRequerida)}`);
                  }
                });
              }
            }
          }
          else{
            this.errores.push("Debe de Seleccionar un Tipo de Salida");
          }
          
        }
        if(this.movimientoItem.idTipoMovimiento == 2){
          if(this.movimientoItem.idArticulo <= 0){
            this.errores.push("Debe de seleccionar un Artículo");
          }

          if(this.movimientoItem.fechaRecepcion == null || this.movimientoItem.fechaRecepcion.length < 16){
            this.errores.push("Falta Ingresar la Fecha de Recepción");
          }
          /* if(this.movimientoItem.fechaIngreso == null || this.movimientoItem.fechaIngreso.length < 16){
            this.errores.push("Falta Ingresar la Fecha de Ingreso");
          } */

          if(this.movimientoItem.idAlmacen <= 0){
            this.errores.push("Falta Seleccionar un Almacén");
          }
          if(this.movimientoItem.idCalidadTipo <= 0){
            this.errores.push("Falta Seleccionar un Tipo de Calidad");
          }

          if(this.movimientoItem.idTrabajoOrden <= 0 && this.movimientoItem.idTrabajoOrdenDetalle > 0){
            this.errores.push("Debe de Seleccionar una Orden de Trabajo");
          }

          if(this.movimientoItem.idTrabajoOrden > 0 && this.movimientoItem.idTrabajoOrdenDetalle <= 0){
            this.errores.push("Debe de Seleccionar un Artículo a Producir");
          }

          if(this.movimientoItem.proveedores.length == 0){
            this.errores.push("Debe Ingresar al menos un Proveedor");
          }
          else{
            var x = 1;
            this.movimientoItem.proveedores.forEach(element => {
              if(element.idProveedorTipo <= 0 || element.idProveedor <= 0){
                this.errores.push("Falta seleccionar Tipo de Proveedor y/o Proveedor en la Fila "+x);
                x += 1;
              }
            });
          }

          if(this.movimientoItem.elementos.length == 0){
            this.errores.push("Debe Ingresar al menos un Elemento");
          }
          else{
            var x = 1;
            this.movimientoItem.elementos.forEach(element => {
              if(isNaN(parseFloat(element.cantidad))){
                this.errores.push("La Cantidad Ingresada en la Fila "+x+ " no es valida")
              }
              else if(parseFloat(element.cantidad) <= 0.0){
                this.errores.push("La Cantidad Ingresada en la Fila "+x+ " debe ser mayor a 0.0")
              }
            });
          }
        }
        if(this.movimientoItem.idTipoMovimiento == 4){
          if(this.movimientoItem.reintegros.length == 0){
            this.errores.push("Debe Ingresar al menos un Reintegro");
          }
          else{
            this.movimientoItem.reintegros.forEach((element,idx) => {
              if(this.expanded.indexOf(element) == -1){
                if(isNaN(parseFloat(element.cantidad))){
                  this.errores.push(`Reintegro #${idx+1}: Debe ingresar una cantidad valida`);
                }
                if(parseFloat(element.cantidad)>element.maximo){
                  this.errores.push(`Reintegro #${idx+1}: La Cantidad ingresada no debe ser mayor a la cantidad maxima`);
                }
                if(parseFloat(element.cantidad)<=0){
                  this.errores.push(`Reintegro #${idx+1}: La Cantidad ingresada no debe ser menor o igual a 0`);
                }
                // Tarima bifurcada (salida parcial): se permite reintegro PARCIAL, no se obliga a desglosar el resto.
                else if(!element.esReintegroParcial && this.validarCantidadMenor(element)){
                  this.errores.push(`Reintegro #${idx+1}: Debe desglosar la cantidad restante`);
                }
              }
              if(element.msgDesgloses.length > 0) this.errores.push(...element.msgDesgloses);
            });
          }
        }
        if(this.movimientoItem.idTipoMovimiento == 7){
          if(this.modoUbicacionQR){
            if(this.movimientosUbicacionQR.length == 0){
              this.errores.push("Pistolea al menos una tarima para reubicar");
            }
          }
          else if(this.movimientosUbicacion.length == 0){
            this.errores.push("Debes agregar al menos un movimiento entre ubicaciones");
          }
        }
      }
      this.error = this.errores.length > 0;
      return this.errores.length == 0;
    },
    async save(confirm=false,confirmedReciente=false){
      //console.log(this.desglosarPayload);
      // Anti doble-envío: si ya hay un guardado en curso, ignora clics adicionales (evita movimientos duplicados).
      if(this.saving) return;
      // Se bloquea de inmediato (antes de validar) para que el botón quede deshabilitado sin ventana de carrera.
      this.saving = true;
      if(!this.validate()){ this.saving = false; return; }

        if(this.movimientoItem.idTipoMovimiento == 7){
          this.saveMovimientoUbicacion();
          return;
        }
        if(this.esIngresoProduccion){
          this.saveIngresoProduccion();
          return;
        }
        if(this.esProduccionSinQr){
          this.saveSalidaProduccionSinQr(confirm);
          return;
        }
        if((this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6) && this.movimientoItem.tipoSalida == 6){
          this.saveSalidaAAlmacen();
          return;
        }

        const normalizarId = (value) => {
          const parsed = parseInt(value, 10);
          if(!Number.isInteger(parsed) || parsed === 0) return null;
          return parsed;
        };
        const obtenerIdArticuloDesdeTrabajoOrdenDetalle = () => {
          const idsDetalle = (this.movimientoItem.idsTrabajoOrdenDetalle || [])
            .map(id => parseInt(id, 10))
            .filter(id => Number.isInteger(id) && id > 0);
          if(idsDetalle.length === 0) return null;
          const detalleSeleccionado = (this.trabajoOrdenDetalles || []).find(detalle => {
            const idDetalle = parseInt(detalle.idTrabajoOrdenDetalle ?? detalle.IdTrabajoOrdenDetalle, 10);
            return Number.isInteger(idDetalle) && idsDetalle.includes(idDetalle);
          });
          if(!detalleSeleccionado) return null;
          return normalizarId(
            detalleSeleccionado.idArticulo ??
            detalleSeleccionado.IdArticulo ??
            detalleSeleccionado.idArticuloProduccion ??
            detalleSeleccionado.IdArticuloProduccion
          );
        };
        const idArticuloDesdeSalidas = normalizarId(
          this.movimientoItem.salidas?.[0]?.idArticulo ??
          this.movimientoItem.salidas?.[0]?.IdArticulo
        );
        const idArticuloPayload =
          (this.movimientoItem.idArticulo > 0 ? this.movimientoItem.idArticulo : null) ??
          obtenerIdArticuloDesdeTrabajoOrdenDetalle() ??
          idArticuloDesdeSalidas;
        var obj = {
          idPublicoVenta: null,
          IdArticulo: idArticuloPayload,
          TipoMovimiento: this.movimientoItem.idTipoMovimiento,
          IdTrabajoOrden: null,
          IdTrabajoOrdenDetalle: null,
          IdsTrabajoOrdenDetalle: null,
          IdCalidadTipo:null,
          Proveedores: null,
          Elementos: null,
          FechaRecepcion:null,
          FechaIngreso: null,
          Salidas:null,
          IdMaquina: null,
          IdOperador: null,
          Reintegros:[],
          lote: null,
          confirmacion: confirm,
          Desgloses: [] 
        };

        if((this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6)){
          obj.TipoSalida = this.movimientoItem.tipoSalida;
          if(this.movimientoItem.tipoSalida == 1){
            const idsTrabajoOrdenDetalle = this.movimientoItem.idsTrabajoOrdenDetalle
              .map(id => parseInt(id, 10))
              .filter(id => Number.isInteger(id) && id > 0);
            const idMaquina = parseInt(this.movimientoItem.idMaquina, 10);
            const idOperador = parseInt(this.movimientoItem.idOperador, 10);
            obj.IdTrabajoOrden = this.movimientoItem.idTrabajoOrden==-1?null:this.movimientoItem.idTrabajoOrden;
            obj.IdTrabajoOrdenDetalle = idsTrabajoOrdenDetalle.length > 0 ? idsTrabajoOrdenDetalle[0] : null;
            obj.IdsTrabajoOrdenDetalle = idsTrabajoOrdenDetalle.length==0?null:idsTrabajoOrdenDetalle;
            obj.IdMaquina = Number.isInteger(idMaquina) && idMaquina > 0 ? idMaquina : null;
            obj.IdOperador = Number.isInteger(idOperador) && idOperador > 0 ? idOperador : null;
            // Si el operador activó "Modificar cantidad", la salida a producción se registra
            // como Salida Parcial (tipo 6), que sí respeta la cantidad capturada por elemento.
            const enviarParcialProduccion = this.editarCantidadSalida;
            if(enviarParcialProduccion){
              obj.TipoMovimiento = 6;
            }
            obj.Salidas = (this.movimientoItem.idTipoMovimiento == 1 && !enviarParcialProduccion)
              ? this.movimientoItem.salidas.map(e => ({
                  IdElemento: normalizarId(e.idElemento),
                  Cantidad: parseFloat(e.maximo)
                }))
              : this.movimientoItem.salidas.map(e => ({
                  IdElemento: normalizarId(e.idElemento),
                  Cantidad: parseFloat(e.cantidad)
                  // Folio nuevo en salida parcial DESACTIVADO a solicitud (arrastra folio original):
                  // FolioNuevo: (e.folioNuevo && e.folioNuevo.toString().trim()) ? e.folioNuevo.toString().trim() : null
                }))
            obj.Desgloses = this.desgloses;
          }
          else if(this.movimientoItem.tipoSalida == 2){
            obj.IdCliente = this.movimientoItem.idCliente;
            obj.Salidas = this.movimientoItem.salidas.map(e => {
              return {
                IdElemento: normalizarId(e.idElemento),
                Cantidad: e.cantidad,
              }
            });
            obj.Desgloses = this.desgloses;
          }

          else if(this.movimientoItem.tipoSalida == 3){
            obj.IdOperador = (this.movimientoItem.idOperador <= 0)?null:this.movimientoItem.idOperador;
            obj.Salidas = this.movimientoItem.salidas.map(e => {
              return {
                IdElemento: normalizarId(e.idElemento),
                Cantidad: e.cantidad,
              }
            });
            obj.Desgloses = this.desgloses;

          }else if(this.movimientoItem.tipoSalida == 4){
            obj.Salidas = this.movimientoItem.salidas.map(e => ({
              IdElemento: normalizarId(e.idElemento),
              Cantidad: parseFloat(e.cantidad)
            }));
            obj.Desgloses = this.desgloses;
          }
          else if(this.movimientoItem.tipoSalida == 5){
            obj.idPublicoVenta = this.movimientoItem.idPublicoVenta;
            obj.Salidas = this.movimientoItem.salidas.map(e => {
              return {
                IdElemento: normalizarId(e.idElemento),
                Cantidad: e.cantidad,
              }
            });
            obj.Desgloses = this.desgloses;
          }
          
        };
        if((this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6) && (!obj.IdArticulo || obj.IdArticulo <= 0)){
          this.saving = false;
          this.error = true;
          this.errores = ["No se pudo determinar el Artículo del movimiento. Vuelve a seleccionar \"Artículo a Producir\" o vuelve a escanear la salida."];
          return;
        }

        //Movimiento de Entrada
        if(this.movimientoItem.idTipoMovimiento == 2){

          //Verifica si es un movimiento reciente
          if(!confirmedReciente){
            await this.checkMovimientoReciente(this.movimientoItem);

            if(this.movimientoRecienteItem.movimientoReciente){
              this.saving = false;
              this.dialogAlertaMovimientoReciente = true;
              this.attentionAnimationKey++;
              return;
            }
          }
                    
          obj.lote = this.movimientoItem.lote;
          obj.FechaRecepcion = this.movimientoItem.fechaRecepcion;
          /* obj.FechaIngreso = this.movimientoItem.fechaIngreso; */
          obj.FechaIngreso = this.movimientoItem.fechaRecepcion;
          obj.IdAlmacen = this.movimientoItem.idAlmacen;
          obj.idSubalmacen = this.movimientoItem.idSubalmacen;
          obj.IdCalidadTipo = this.movimientoItem.idCalidadTipo;
          obj.IdTrabajoOrden = this.movimientoItem.idTrabajoOrden==-1?null:this.movimientoItem.idTrabajoOrden;
          obj.IdTrabajoOrdenDetalle = this.movimientoItem.idTrabajoOrdenDetalle==-1?null:this.movimientoItem.idTrabajoOrdenDetalle;
          obj.Descripcion = this.movimientoItem.descripcion;
          obj.Proveedores = this.movimientoItem.proveedores.map(element => {
            return {
              IdProveedorTipo: element.idProveedorTipo,
              IdProveedor: element.idProveedor 
            }
          });
          obj.Elementos = [];
          this.movimientoItem.elementos.forEach(element => {
            //Se seleccionan los valores que se van a enviar
            const lote = element.lote || this.movimientoItem.lote || null;
            const folio = element.Folio || null;
            //Se asignan los valores en sus respectivas variables dentro de un objeto del tipo MovimientoElementosViewModel
            if(parseInt(element.multiplicar) == 1){              
              obj.Elementos.push({
                cantidad: parseFloat(element.cantidad),
                numLote: lote,
                folio: folio
              });
            }
            else if(parseInt(element.multiplicar) > 1){
                obj.Elementos = obj.Elementos.concat(Array(parseInt(element.multiplicar)).fill({
                cantidad: parseFloat(element.cantidad),
                numLote: lote,
                folio: folio
              }));
            }
          });
        }

        if(this.movimientoItem.idTipoMovimiento == 4){
          const reintegrosParciales = this.movimientoItem.reintegros.filter(e => e.esReintegroParcial);
          const reintegrosNormales = this.movimientoItem.reintegros.filter(e => !e.esReintegroParcial);

          // No se pueden mezclar tarimas bifurcadas (salida parcial) con reintegros normales en un mismo envío.
          if(reintegrosParciales.length > 0 && reintegrosNormales.length > 0){
            this.saving = false;
            this.error = true;
            this.errores = ["No mezcles tarimas de salida parcial con reintegros normales en el mismo movimiento; realízalos por separado."];
            return;
          }

          // Reintegro de tarimas bifurcadas: endpoint nuevo, el material regresa como esa tarima (su QR).
          if(reintegrosParciales.length > 0){
            const payload = {
              Reintegros: reintegrosParciales.map(e => ({
                // Reintegro PARCIAL: se devuelve SOLO lo capturado en "Cantidad"; el resto queda consumido.
                // (No se usa desglose para tarimas bifurcadas; el back acredita la tarima por esta cantidad.)
                IdElemento: normalizarId(e.idElemento),
                Cantidad: parseFloat(e.cantidad)
              }))
            };
            axios
              .post("/Inventario/ReintegrarSalidaParcial", payload)
              .then(() => {
                this.saving = false;
                this.close(1);
              })
              .catch(error => {
                this.saving = false;
                if(error.response && error.response.data && error.response.data.msg){
                  this.errores = [error.response.data.msg];
                  this.error = true;
                }
                console.log(error);
              });
            return;
          }

          obj.Reintegros = reintegrosNormales.map(e =>({
            IdElemento: normalizarId(e.idElemento),
            Cantidad: parseFloat(e.cantidad),
            ots: e.trabajoOrdenes.ordenesTrabajoDetalle.map(odt => ({
                ...odt,
                cantidad: parseFloat(odt.cantidad),
                idArticulo: e.idArticulo
              })),
            idMovimientoPublicoVenta: e.idMovimientoPublicoVenta
          }));
        }

        // IdArticulo es int no anulable en el back; si no se resolvió (p.ej. reintegro),
        // se envía -1 para no romper el model binding (comportamiento previo).
        if(obj.IdArticulo == null || isNaN(obj.IdArticulo)) obj.IdArticulo = -1;

        axios
          .post("/Inventario/CrearMovimiento",obj)
          //console.log(obj)
          .then(response => {
            this.cerrarDialogAlertaMovimientoReciente();
            this.cerrarDialogAlertaMP();
            //console.log(obj);
            this.saving = false;
            this.obj = obj;
            //console.log(obj.Desgloses);
            if(
              (this.salidasQR && this.movimientoItem.idTipoMovimiento == 1) ||
              this.movimientoItem.idTipoMovimiento == 2 ||
              this.movimientoItem.idTipoMovimiento == 6
            ){
              if(response.data != null && response.data.length > 0){
                this.qrPdf = response.data;
                this.state = 1;
              }
              else{
                // No se generó QR (p.ej. salida a cliente con QR desactivado aunque salidasQR=true):
                // cerrar normalmente y refrescar la lista, en vez de dejar la ventana abierta.
                this.close(1);
              }
            }
            else{
              this.close(1);
            }
          })
          .catch(error => {
            this.saving = false;
            if(error.response){
              if(error.response.status==409){
                this.dialogAlertaMP = true;
                this.lottieKey++;
              }
              else if(error.response.data && error.response.data.msg){
                this.errores = [error.response.data.msg];
                this.error = true;
              }
            }
            console.log(error);
          })
    },
    checkMovimientoReciente({idAlmacen, idArticulo}){
      return new Promise( async(resolve) => {
        try{
          const response = await axios.get(`/Inventario/MovimientoRecienteAlmancen`,{
            params: {
              idAlmacen,
              idArticulo
            }
          });
          this.movimientoRecienteItem = response.data;
        }
        catch(error){
          console.log(error);
        }
        finally{
          resolve();
        }
      });
    },
    newElemento(){
      this.movimientoItem.elementos.push(Object.assign({},this.elementoDefault));
      var x = 1;
      this.movimientoItem.elementos.forEach(element => {
        element.numElemento = x;
        x += 1;
      });
    },
    deleteElemento(item){
      var x = 1;
      this.movimientoItem.elementos = this.movimientoItem.elementos.filter(element => {
        return element.numElemento !=  item.numElemento;
      });
      this.movimientoItem.elementos.forEach(element => {
        element.numElemento = x;
        x += 1; 
      });
    },
    newProveedor(){
      this.movimientoItem.proveedores.push(Object.assign({},this.proveedorDefault));
    },
    deleteProveedor(item){
      var pos = this.movimientoItem.proveedores.indexOf(item);
      if (pos > -1) {
        this.movimientoItem.proveedores.splice(pos, 1);
      }
    },
    deleteReintegro(item){
      var pos = this.movimientoItem.reintegros.indexOf(item);
      if(pos > -1){
        this.movimientoItem.reintegros.splice(pos,1);
        const indexExpanded = this.expanded.indexOf(item);
        if(indexExpanded > -1) this.expanded.splice(indexExpanded, 1);
      }
    },
    validarCantidadMenor(item){
      if(item.idMovimientoPublicoVenta==null){
        return parseFloat(item.cantidad) < item.maximo;
      }

      return false;
    },
    validarCantidad(cantidad, minimo = 0.0){
      if(isNaN(parseFloat(cantidad))) return true;

      if(parseFloat(cantidad) <= minimo) return true;

      return false;
    },
    deleteSalida(item){
      var pos = this.movimientoItem.salidas.indexOf(item);
      if (pos > -1) {
        this.movimientoItem.salidas.splice(pos, 1);
      }
    },
    onDecode(code){
      if((this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6) || this.movimientoItem.idTipoMovimiento == 4){
        if(this.movimientoItem.salidas.find(s => s.codigo == code) != null || this.movimientoItem.reintegros.find(s => s.codigo == code) != null){
          this.soundError.play();
          this.$notify({
            group: 'inventario',
            title: 'Se ha seleccionado un Elemento con el Código '+code.match(/.{1,3}/g).join('-'),
            type: 'error',
          });
          return;
        }
        if(this.movimientoItem.idTipoMovimiento == 1 && this.movimientoItem.tipoSalida == 5){
          if(this.movimientoItem.idPublicoVenta == null){
            this.errorOrdenVenta = "Debe seleccionar una Orden de Venta";
            this.soundError.play();
            this.$notify({
              group: 'inventario',
              title: 'Debe seleccionar una Orden de Venta',
              type: 'error',
            });
            return;
          }
        }
      }
      axios
      .get("/Inventario/InformacionBasica?Codigo="+code+"&tipoMovimiento="+this.movimientoItem.idTipoMovimiento)
      .then(response => {
        if((this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6)){
          if(response.data.enUso){
            this.soundError.play();
            this.$notify({
              group: 'inventario',
              title: 'No se puede agregar el Elemento con el Código '+code.match(/.{1,3}/g).join('-')+" se encuentra en uso en otra ODT",
              type: 'error',
            });
            return;
          }

          this.maximo= response.data.maximo;
          this.IdElemento = response.data.idElemento;
          let indexArticuloOrdenVenta = -1;

          if(this.movimientoItem.idTipoMovimiento == 1 && this.movimientoItem.tipoSalida == 5){
            indexArticuloOrdenVenta = this.articulosOrdenVenta
                                          .map(venta => venta.idArticulo)
                                          .indexOf(response.data.idArticulo);
            if(indexArticuloOrdenVenta == -1){
              this.soundError.play();
              this.$notify({
                group: 'inventario',
                title: 'No se puede agregar el Elemento porque no coincide con ningun artículo de la Orden de Venta seleccionada',
                type: 'error',
              });
              return;
            }
            else if( this.articulosOrdenVenta[indexArticuloOrdenVenta].cantidadRestante == 0 ){
              this.soundError.play();
              this.$notify({
                group: 'inventario',
                title: 'No se puede agregar el Elemento porque ya se surtió la cantidad requerida del artículo',
                type: 'error',
              });
              return;
            }
            
          }

          if(response.data.maximo <= 0){
            this.soundError.play();
            this.$notify({
              group: 'inventario',
              title: 'La existencia de este Elemento es 0.0 '+response.data.abreviatura,
              type: 'error',
            });
            return;
          }
          
          var idsAlmancenes = this.almacenes.filter(a => a.idCliente == null).map(a => a.idAlmacen);
          var pos = this.trabajoOrdenes.findIndex(element => element.idTrabajoOrden == this.movimientoItem.idTrabajoOrden);
          if(pos >= 0 && this.trabajoOrdenes[pos].maquila){
            idsAlmancenes.push(this.trabajoOrdenes[pos].idAlmacen);
          }
          if(idsAlmancenes.indexOf(response.data.idAlmacen) >= 0){
            response.data.cantidad = (this.movimientoItem.idTipoMovimiento == 1 && (this.movimientoItem.tipoSalida == 1 || this.movimientoItem.tipoSalida == 2 || this.movimientoItem.tipoSalida == 4))
              ? response.data.maximo
              : 0;
            if( indexArticuloOrdenVenta > -1 ){
              response.data.cantidadRequerida = this.articulosOrdenVenta[indexArticuloOrdenVenta].cantidadRestante;
            }
            // Folio nuevo en salida parcial DESACTIVADO a solicitud (arrastra folio original):
            // response.data.folioNuevo = null;
            this.movimientoItem.salidas.push(response.data);
            this.soundBeep.play();
          }
          else{
            this.soundError.play();
            this.$notify({
              group: 'inventario',
              title: 'No se puede agregar el Elemento con el Código '+code.match(/.{1,3}/g).join('-'),
              type: 'error',
            });
          }
        }
        if(this.movimientoItem.idTipoMovimiento == 4){
          if(!response.data.enUso){
            this.soundError.play();
            this.$notify({
              group: 'inventario',
              title: 'No se puede agregar el Elemento con el Código '+code.match(/.{1,3}/g).join('-')+" se encuentra en uso en otra ODT",
              type: 'error',
            });
            return;
          }
          else{
            response.data.cantidad = 0.0;
            response.data.msgDesgloses = [];
            response.data.trabajoOrdenes.ordenesTrabajoDetalle = response.data.trabajoOrdenes.ordenesTrabajoDetalle != null
              ? response.data.trabajoOrdenes.ordenesTrabajoDetalle.map( odt => ({
                  ...odt,
                  idTrabajoOrden: response.data.trabajoOrdenes.idTrabajoOrden,
                  cantidad: 0
                }))
              : [];
            this.movimientoItem.reintegros.push(response.data);
            this.soundBeep.play();
          }
        }
      })
      .catch(error => {
        if((this.movimientoItem.idTipoMovimiento == 1 || this.movimientoItem.idTipoMovimiento == 6) && this.movimientoItem.tipoSalida == 6){
          this.intentarAgregarSalidaDesdeLogistica(code).then(agregado => {
            if(agregado){
              this.soundBeep.play();
              return;
            }
            this.soundError.play();
            this.$notify({
              group: 'inventario',
              title: 'No se encontró el código '+code.match(/.{1,3}/g).join('-')+' en Elementos ni en entradas de logística',
              type: 'error',
            });
          });
          return;
        }
        // Reintegro: si el elemento no existe por la vía normal, puede ser una tarima bifurcada (salida parcial).
        if(this.movimientoItem.idTipoMovimiento == 4){
          this.intentarAgregarReintegroParcial(code).then(agregado => {
            if(agregado){
              this.soundBeep.play();
              return;
            }
            this.soundError.play();
            this.$notify({
              group: 'inventario',
              title: 'No Existe un Elemento con el Código '+code.match(/.{1,3}/g).join('-'),
              type: 'error',
            });
          });
          return;
        }
        this.soundError.play();
        this.$notify({
          group: 'inventario',
          title: 'No Existe un Elemento con el Código '+code.match(/.{1,3}/g).join('-'),
          type: 'error',
        });
      });
    },
    setCodeStyle(){
      if(this.codigo.length >= 1){
        try{
          if(this.codigo[0] == '@' && this.codigo.length > 1){
            this.codigo = "@" + this.codigo.substring(1).toUpperCase().replace(/-/g, '').match(/.{1,3}/g).join('-');
          }

          else this.codigo = this.codigo.toUpperCase().replace(/-/g, '').match(/.{1,3}/g).join('-');
        }
        catch{
          this.codigo = '';
        }
      }
    },
    setCodeStyleReturn(codigo){
      if(codigo.length >= 1){
        try{
          if(codigo[0] == '@' && codigo.length > 1){
            return "@" + codigo.substring(1).toUpperCase().replace(/-/g, '').match(/.{1,3}/g).join('-');
          }

          else return codigo.toUpperCase().replace(/-/g, '').match(/.{1,3}/g).join('-');
        }
        catch{
          return '';
        }
      }
    },
    getCode(){
      var codigo = this.codigo.toUpperCase().replace(/-/g, '');
      if(codigo.length == 10 && codigo[0] == "@"){
        this.onDecode(codigo);
        this.codigo = "";
      }
      if(codigo.length == 9 && this.onlyNumberAndLetters(codigo)){
        this.onDecode(codigo);
        this.codigo = "";
      }
    },
    validCode(str){
      if(str[0] == '@'){
        return this.onlyNumberAndLetters(str.substring(1).replace(/-/g, ''));
      }
      else return this.onlyNumberAndLetters(str.replace(/-/g, ''));
    },
    onlyNumberAndLetters(str) {
      return str.match("^[A-Z0-9-]+$");
    },
    notificacionInventario(event) {
      var orden = event.toLowerCase().split('-');
      if(orden[0] == 'lecturaremota'){
        if(this.idUser == parseInt(orden[1])){
          this.getLecturasRemotas();
        }
      }
    },
    getLecturasRemotas(){
      this.loadingLecturasRemotas = true;
      axios
      .get("/Inventario/ListarQRRemotos")
      .then(response => {
        this.lecturasRemotas = response.data;
        this.loadingLecturasRemotas = false;
      })
      .catch(error => {
        this.loadingLecturasRemotas = false;
        console.log(error);
      })
    },
    selectedCode(event){
      this.onDecode(event);
      setTimeout(() => {
        this.selectCode = null;
      },200);
    },
    findAndEdit(numElemento, newCantidad) {
      const elemento = this.movimientoItem.elementos.find(obj => obj.numElemento === numElemento);
      if (elemento) {
          elemento.cantidad = newCantidad;
      }
      return this.movimientoItem.elementos;
    },
    editSalidaParcial(elementos, nerCantidad){
      const elemento = this.movimientoItem.salidas.find(obj => 
      obj.codigo == elementos.codigo && obj.idElemento == elementos.idElemento &&
      obj.almacen == elementos.almacen && obj.articulo == elementos.articulo)
      if(elementos)
        elemento.cantidad = nerCantidad

        return this.movimientoItem.elementos;
    },
    emitirRecuperarDato(type, item) {
      console.log(item)
      this.cantidad = 0;
      this.loadRecorverDate = true;
      this.cantidadAuxiliar = 0;
      console.log(type)
      axios
        .get("/SensorDatos/DatoBascula")
        .then(response => {
          var mongoObjecst = JSON.parse(response.data)
          //console.log(parseFloat(mongoObjecst.maquina1_PESOUBRUTO))
          if(type == 1) 
          this.findAndEdit(item.numElemento ,parseFloat(mongoObjecst.maquina1_Bruto))

          if(type == 2)
          this.editSalidaParcial(item,parseFloat(mongoObjecst.maquina1_Bruto));

          /* if(type == 1)
          this.cantidad = parseFloat(mongoObjecst.maquina1_PESOUBRUTO)

          if(type == 2)
          this.cantidadMerma = parseFloat(mongoObjecst.maquina1_PESOUBRUTO)

          if(type == 3)
          this.cantidadScrap = parseFloat(mongoObjecst.maquina1_PESOUBRUTO)
          
          if(type == 4){
            this.updateCantidadAuxiliar(parseFloat(mongoObjecst.maquina1_PESOUBRUTO)) 
            this.uaxkey++;
          } */
          this.loadRecorverDate = false;
          
        })
        .catch(error => {
          this.loadRecorverDate = false;
          this.cantidad = 0;
          console.log(error);
        }) 
      },
    recoverData(type){
    },
    getSinDesglosar() {  //De aquí
			this.loading = true;
			axios
				.get("/Mantenimientos/MovimientosSinDesglosar")
				.then((response) => {
          this.sinDesglosar = response.data;
          this.movimientoDesglose.cantidadFaltante = this.maximo
          //console.log(this.movimientoDesglose.cantidadFaltante)
					this.loading = false;
				})
				.catch((error) => console.log(error));
		},
    convert3D(num, index) {
			if (this.cantidadRule(num) === true) {
				this.cantidades[index] = parseFloat(num).toFixed(2);
				this.validarCantidades();
			}
		},
    desglosarMovimiento(item) {
      const inputCantidad = item.cantidad;
      const cantidadAUsar =inputCantidad !== undefined && inputCantidad !== null && inputCantidad !== '' && inputCantidad !== 0 ? inputCantidad : item.maximo;
			this.movimientoDesglose.idMovimientoDetalle = this.IdElemento;
			this.movimientoDesglose.cantidadFaltante = cantidadAUsar;
			this.movimientoDesglose.unidad = item.unidad;
      //console.log(item);
      this.dialogDesglosar = true;
		},
    validarCantidades() {
      this.errores = [];
      this.calcularSumatoria();

      if (this.movimientoDesglose.cantidadFaltante === undefined) {
        console.error("cantidadFaltante is undefined");
        return;
      }

      if (this.movimientoDesglose.unidad === undefined) {
        console.error("unidad is undefined");
        return;
      }

      if (this.movimientoDesglose.cantidadFaltante === this.totality) {
        this.cantidadesValidos = true;
      } else {
        this.cantidadesValidos = false;
        this.errores.push(
          `La SUMATORIA no es igual al TOTAL (${this.movimientoDesglose.cantidadFaltante.toFixed(2)} ${this.movimientoDesglose.unidad}) de la movimiento.`
        );
      }
  },

    calcularSumatoria(){
			this.totality = 0;
			this.cantidades.forEach((cantidad,index) => {
				if (this.cantidadRule(cantidad) === true) {
					this.porcentajes[index] = this.calcularPorcentaje(this.movimientoDesglose.cantidadFaltante,parseFloat(cantidad));
					this.totality += parseFloat(cantidad);
				}
      //console.log(this.cantidades)  
			});
			this.totality = parseFloat(parseFloat(this.totality).toFixed(2));
		},
    lblcodNom: (item) =>
			item !== null &&
			`[${item.mantenimientoCodigo}] - ${item.mantenimiento}`,
    showDialogHistorial() {
			this.loadingHistorial = true;
			setTimeout(() => {
				this.dialogHistorial = true;
			}, 250);
		},
    clickGuardarSelected() {
			const items = this.$refs.historyMan.clickSeleccionados();
			this.movimientoDesglose.payload = items.map((mantenimiento) => ({
				...mantenimiento,
				fechaAplicacion: null,
				porcentaje: 0,
				cantidad: 0,
			}));
      //console.log(this.movimientoDesglose)
			this.dialogHistorial = false;
			this.loadingHistorial = false;
			this.totality = 0;
			this.porcentajes = [];
			this.cantidades = [];
			this.errores = [];
			this.porcentajesValidos = false;
			this.cantidadesValidos = false;
		},
    calcularPorcentaje(total,cantidad){
			return ((cantidad*100)/total).toFixed(2);
		},
    distribuirTotal(){
			this.totality = 0;
			this.cantidades =[];
			this.porcentajes = [];
			this.movimientoDesglose.payload.forEach((item, index) => {
				this.cantidades[index] = (this.movimientoDesglose.cantidadFaltante / this.movimientoDesglose.payload.length).toFixed(2);
				this.porcentajes[index] = this.calcularPorcentaje(this.movimientoDesglose.cantidadFaltante,this.cantidades[index]);
      //console.log(this.movimientoDesglose.payload)  
			});
			this.calcularSumatoria();
			const residuo = parseFloat(this.movimientoDesglose.cantidadFaltante) - parseFloat(this.totality);
			if ( residuo !== 0) this.cantidades[0] = (parseFloat(this.cantidades[0]) + parseFloat(parseFloat(residuo).toFixed(2))).toFixed(2);  
			setTimeout(() => {
				// this.validarPorcentajes();
				this.validarCantidades();
			}, 250);
		},
    cerrarDialogHistorial() {
			this.dialogHistorial = false;
			setTimeout(() => {
				this.$refs.historyMan.resetSeleccionados();
			}, 250);
			this.loadingHistorial = false;
		},
    validarPorcentajes() {
			this.errores = [];
			let porciento = 0;
			this.porcentajes.forEach((porcentaje) => {
				if (this.numberRule(porcentaje) === true) {
					porciento += parseFloat(porcentaje);
				}
			});
			if (porciento === 100) this.porcentajesValidos = true;
			else {
				this.porcentajesValidos = false;
				this.errores.push("Los porcentajes no suman el 100%");
			}
		},
    closeDesglosar() {
			this.totality = 0;
			this.porcentajes = [];
			this.cantidades = [];
			this.errores = [];
      //this.desgloses = [],
			this.porcentajesValidos = false;
			this.cantidadesValidos = false;
			this.dialogDesglosar = false;
			setTimeout(() => {
				if(this.$refs.historyMan !== undefined)
					this.$refs.historyMan.fullresetSeleccionados();
			}, 250);
			this.movimientoDesglose = Object.assign(
				[],
				this.defaultmovimientoDesglose
			);
		},
    guardarDesglosar() { //Función para obetner los datos del desglose 
      const fechaNow = moment().format("yyyy-MM-DD HH:mm");
      const payload = this.movimientoDesglose.payload.map(
        (mantenimiento, index) => ({
          idMantenimientoTarea: mantenimiento.idMantenimientoTarea,
          fechaAplicacion: fechaNow,
          porcentaje: parseFloat(this.porcentajes[index]),
          cantidad: parseFloat(this.cantidades[index]),
        })
      );

      const siExiste = this.desgloses.findIndex(d => d.IdElemento === this.IdElemento);

      if (siExiste !== -1) {
        this.desgloses[siExiste].Desgloses.push(...payload);
      } else {
        this.desgloses.push({
          IdElemento: this.IdElemento,
          Desgloses: payload,
        });
        //console.log("Desgloses acumulados", this.desgloses);
        this.savingDesglosar = false;
        this.closeDesglosar();
      }
    }
  }
}
</script>
<style scoped>
  .centered-input >>> input {
    text-align: center
  }

  .custom-btn {
    color: #6D6D6D !important;
  }

  .align-center {
    align-items: center; /* Alineación vertical al centro */
  }
  .custom-btn {
    height: 40px; /* Ajustar según el tamaño deseado */
    width: 40px; /* Ajustar según el tamaño deseado */
  }
</style>
